import { Injectable } from "@angular/core";
import { Observable } from "rxjs/Rx";
import { Subject } from "rxjs/Subject";
import Amplify, { API, graphqlOperation } from "aws-amplify";
import { GraphQLResult } from "aws-amplify/lib/API/types";
// import aws_exports from '../../../../awsmobilejs/#current-backend-info/aws-exports';
import "rxjs/add/operator/toPromise";
import "rxjs/add/operator/map";
import { Users } from "../../models/users";
import { TripMaster } from "../../models/TripMaster";
import { DriverTripDetailsModel } from "../../models/driverTripDetails";
import { AppConstants } from "../../constants/app-constants";
import { promise } from "protractor";
import { HttpClient, HttpParams } from "@angular/common/http";
import { HttpHeaders } from "@angular/common/http";
import { environment } from "../../../environments/environment";
var CryptoJS = require("crypto-js");

// let myAppConfig = {
//   'aws_appsync_graphqlEndpoint': 'https://f333bltb3rer7bjsup4cioi6h4.appsync-api.ap-south-1.amazonaws.com/graphql',
//   'aws_appsync_region': 'ap-south-1',
//   'aws_appsync_authenticationType': 'API_KEY',
//   'aws_appsync_apiKey': 'da2-in3qxoxirzfihj2x7r54sldjx4',
// }
// let myAppConfig = {
//   // ...
//   'aws_appsync_graphqlEndpoint': 'https://7wogkpocife2tdyq2be7emufne.appsync-api.ap-south-1.amazonaws.com/graphql',
//   'aws_appsync_region': 'ap-south-1',
//   'aws_appsync_authenticationType': 'API_KEY',
//   'aws_appsync_apiKey': 'da2-ykjhe43tpnfdlhhtn7trar2vze',
// }
// let myAppConfig = {
//   // ...
//   'aws_appsync_graphqlEndpoint': 'https://t5ttpnldwjbgronm5544cw5dpa.appsync-api.ap-south-1.amazonaws.com/graphql',
//   'aws_appsync_region': 'ap-south-1',
//   'aws_appsync_authenticationType': 'API_KEY',
//   'aws_appsync_apiKey': 'da2-wlmgdmv4rjcjtkmrs46ptp5g64',
// }

// Production
// let myAppConfig = {
//   // ...
//   'aws_appsync_graphqlEndpoint': 'https://kufslz7ccfddlhnyj7fbngmozi.appsync-api.ap-south-1.amazonaws.com/graphql',
//   'aws_appsync_region': 'ap-south-1',
//   'aws_appsync_authenticationType': 'API_KEY',
//   'aws_appsync_apiKey': 'da2-xej2cau5jvdw5dqrqsozfpdknq'
// }

// Stagginh
// let myAppConfig = {
//   aws_appsync_graphqlEndpoint:
//     "https://w4tjgxrxvnguldsclbiqylytm4.appsync-api.ap-south-1.amazonaws.com/graphql",
//   aws_appsync_region: "ap-south-1",
//   aws_appsync_authenticationType: "API_KEY",
//   aws_appsync_apiKey: "da2-qcuqmnkwyrev7pxws67x7gkh7a"
// };

let myAppConfig = environment.myAppConfig;

Amplify.configure(myAppConfig);

@Injectable()
export class AwsService {
  public userTrips: [any];
  public userDetail: {};
  public route_trips: [any];
  public positionsUpdate = new Subject<[Object]>();
  public positionsUpdate$ = this.positionsUpdate.asObservable();
  constructor(private httpClient: HttpClient) { }
  createTripPosition() { }

  RncUsersAll(): Promise<any> {
    let promise = new Promise((resolve, reject) => {
      var that = this;
      var myPromise = API.graphql(
        graphqlOperation(AppConstants.ListRncUsers)
      ) as Promise<GraphQLResult>;
      myPromise
        .then((result) => {
          resolve(
            result.data[
              AppConstants.list + AppConstants.env + AppConstants.RncUsers
            ].items
          );
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
    return promise;
  }
  LoginRncUser(user_name: String): Promise<any> {
    let promise = new Promise((resolve, reject) => {
      var that = this;
      var myPromise = API.graphql(
        graphqlOperation(AppConstants.LoginFindUser, { user_name: user_name })
      ) as Promise<GraphQLResult>;
      myPromise
        .then((result) => {
          resolve(
            result.data[
              AppConstants.list + AppConstants.env + AppConstants.RncUsers
            ].items
          );
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
    return promise;
  }

  findUserById(id: String): Promise<any> {
    console.log("API_findUserById", id);
    let promise = new Promise((resolve, reject) => {
      var that = this;
      var myPromise = API.graphql(
        graphqlOperation(AppConstants.findUserById, {
          id: id,
        })
      ) as Promise<GraphQLResult>;
      myPromise
        .then((result) => {
          //  console.log(AppConstants.list + AppConstants.env + AppConstants.RncUsers)
          resolve(
            result.data[
              AppConstants.list + AppConstants.env + AppConstants.RncUsers
            ].items
          );
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
    return promise;
  }

  findUserByUserName(user_name: String): Promise<any> {
    let promise = new Promise((resolve, reject) => {
      var that = this;
      var myPromise = API.graphql(
        graphqlOperation(AppConstants.findUserByUserName, {
          user_name: user_name,
        })
      ) as Promise<GraphQLResult>;
      myPromise
        .then((result) => {
          //  console.log(AppConstants.list + AppConstants.env + AppConstants.RncUsers)
          resolve(
            result.data[
              AppConstants.list + AppConstants.env + AppConstants.RncUsers
            ].items
          );
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
    return promise;
  }

  // getRncUsers(id): Promise<any> {
  //   let promise = new Promise((resolve, reject) => {
  //     var that = this;
  //     var myPromise = API.graphql(
  //       graphqlOperation(AppConstants.GetRncUserLocationById, { id: id })
  //     ) as Promise<GraphQLResult>;
  //     myPromise
  //       .then((result) => {
  //         //  console.log(AppConstants.list + AppConstants.env + AppConstants.RncUsers)
  //         resolve(
  //           result.data[
  //             AppConstants.getq + AppConstants.env + AppConstants.RncUsers
  //           ]
  //         );
  //       })
  //       .catch((error) => {
  //         console.log(error);
  //         reject(error);
  //       });
  //   });
  //   return promise;
  // }

  //FindUserHome Location
  getRncUsersLocation(id): Promise<any> {
    let promise = new Promise((resolve, reject) => {
      var that = this;
      var myPromise = API.graphql(
        graphqlOperation(AppConstants.GetRncUserLocationById, { id: id })
      ) as Promise<GraphQLResult>;
      myPromise
        .then((result) => {
          //  console.log(AppConstants.list + AppConstants.env + AppConstants.RncUsers)
          resolve(
            result.data[
            AppConstants.getq + AppConstants.env + AppConstants.RncUsers
            ]
          );
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
    return promise;
  }

  getMetaData(): Promise<any> {
    let promise = new Promise((resolve, reject) => {
      var myPromise = API.graphql(
        graphqlOperation(AppConstants.getMetaData)
      ) as Promise<GraphQLResult>;
      myPromise
        .then((result) => {
          resolve(
            result.data[
              AppConstants.list + AppConstants.env + AppConstants.ScMetaData
            ].items
          );
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
    return promise;
  }

  getRncUsersByType(user_type: number): Promise<any> {
    let promise = new Promise((resolve, reject) => {
      var that = this;
      var myPromise = API.graphql(
        graphqlOperation(AppConstants.GetUsersByType, { user_type: user_type })
      ) as Promise<GraphQLResult>;
      myPromise
        .then((result) => {
          resolve(
            result.data[
              AppConstants.list + AppConstants.env + AppConstants.RncUsers
            ].items
          );
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
    return promise;
  }
  getRncUsersByTypeByToken(user_type: number): Promise<any> {
    let promise = new Promise((resolve, reject) => {
      var that = this;
      var myPromise = API.graphql(
        graphqlOperation(AppConstants.GetUsersByType, { user_type: user_type })
      ) as Promise<GraphQLResult>;
      myPromise
        .then((result) => {
          resolve(
            result.data[
            AppConstants.list + AppConstants.env + AppConstants.RncUsers
            ]
          );
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
    return promise;
  }

  getRncUsersByTypeByNextToken(
    user_type: number,
    nextToken: string
  ): Promise<any> {
    let promise = new Promise((resolve, reject) => {
      var that = this;
      var myPromise = API.graphql(
        graphqlOperation(AppConstants.GetUsersByTypeByToken, {
          user_type: user_type,
          nextToken: nextToken,
        })
      ) as Promise<GraphQLResult>;
      myPromise
        .then((result) => {
          resolve(
            result.data[
            AppConstants.list + AppConstants.env + AppConstants.RncUsers
            ]
          );
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
    return promise;
  }

  getDriverVehcile(driver_id: String): Promise<any> {
    let promise = new Promise((resolve, reject) => {
      var that = this;
      var myPromise = API.graphql(
        graphqlOperation(AppConstants.GetDriverVehicle, {
          driver_id: driver_id,
        })
      ) as Promise<GraphQLResult>;
      myPromise
        .then((result) => {
          // console.log("result",result)
          resolve(
            result.data[
              AppConstants.list +
              AppConstants.env +
              AppConstants.listDaVehicleMasters
            ].items
          );
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
    return promise;
  }

  updateVehicleMasterlimit(id, office_lat, office_long): Promise<any> {
    let promise = new Promise((resolve, reject) => {
      var that = this;
      let dateFormat = require("dateformat");
      let now = new Date();
      var myPromise = API.graphql(
        graphqlOperation(AppConstants.UpdateVehicleMasterGeoFenceLimit, {
          id: id,
          office_address: {
            lat: office_lat,
            long: office_long,
            address: "RNTBCI",
          },
        })
      ) as Promise<GraphQLResult>;
      myPromise
        .then((result) => {
          resolve(
            result.data[
            AppConstants.update +
            AppConstants.env +
            AppConstants.DaVehicleMaster
            ]
          );
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
    return promise;
  }

  // update wellness date
  updateWellnessFeedback(id, feedback_month, feedback_date): Promise<any> {
    let promise = new Promise((resolve, reject) => {
      var that = this;
      let dateFormat = require("dateformat");
      let now = new Date();
      var myPromise = API.graphql(
        graphqlOperation(AppConstants.updateWelnessDate, {
          id: id,
          feedback_date: feedback_date,
          feedback_month: feedback_month,
        })
      ) as Promise<GraphQLResult>;
      myPromise
        .then((result) => {
          resolve(
            result.data[
            AppConstants.update +
            AppConstants.env +
            AppConstants.AppFitnessFeedback
            ]
          );
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
    return promise;
  }

  encryptLatLong(
    id,
    home_lat,
    home_long,
    office_lat,
    office_long
  ): Promise<any> {
    // encryptLatLong(id,ph): Promise<any> {
    let promise = new Promise((resolve, reject) => {
      var that = this;
      let dateFormat = require("dateformat");
      let now = new Date();
      var myPromise = API.graphql(
        graphqlOperation(AppConstants.encrypt, {
          id: id,
          //  user_phone_number : ph
          // office_address: {
          //   lat: office_lat,
          //   long: office_long
          //   //address: "RNTBCI"
          // },
          // home_address: {
          //   lat: home_lat,
          //   long: home_long
          //   //address: "RNTBCI"
          // }

          office_address: {
            elat: office_lat,
            elong: office_long,
            address: "RNTBCI",
          },
          home_address: {
            elat: home_lat,
            elong: home_long,
            address: "HOME",
          },
        })
      ) as Promise<GraphQLResult>;
      myPromise
        .then((result) => {
          resolve(
            result.data[
            AppConstants.update +
            AppConstants.env +
            AppConstants.DaVehicleMaster
            ]
          );
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
    return promise;
  }

  // encryptLatLong(id,home_lat,home_long,office_lat,office_long): Promise<any> {

  updaterm(
    id,
    s_address,
    e_address,
    os_address,
    oe_address,
    s_date,
    e_date,
    os_date,
    oe_date
  ): Promise<any> {
    let promise = new Promise((resolve, reject) => {
      var that = this;
      let dateFormat = require("dateformat");
      let now = new Date();
      var myPromise = API.graphql(
        graphqlOperation(AppConstants.rmapp, {
          trip_id: id,
          duty_start: {
            address: s_address,
            date_time: s_date,
          },
          duty_end: {
            address: e_address,
            date_time: e_date,
          },
          outstation_duty_start: {
            address: os_address,
            date_time: os_date,
          },
          outstation_duty_end: {
            address: oe_address,
            date_time: oe_date,
          },
        })
      ) as Promise<GraphQLResult>;
      myPromise
        .then((result) => {
          resolve(
            result.data[
            AppConstants.update +
            AppConstants.env +
            AppConstants.DaVehicleMaster
            ]
          );
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
    return promise;
  }

  updateVehicleMaster(vhclmst): Promise<any> {
    let promise = new Promise((resolve, reject) => {
      var that = this;

      console.log("vehiclemaster", vhclmst.home_lat);

      let hlat = CryptoJS.AES.encrypt(
        vhclmst.home_lat.toString(),
        AppConstants.cryptoKey
      ).toString();
      console.log("hlat", hlat);
      let hlong = CryptoJS.AES.encrypt(
        vhclmst.home_long.toString(),
        AppConstants.cryptoKey
      ).toString();
      let olat = CryptoJS.AES.encrypt(
        vhclmst.office_lat.toString(),
        AppConstants.cryptoKey
      ).toString();
      let olong = CryptoJS.AES.encrypt(
        vhclmst.office_long.toString(),
        AppConstants.cryptoKey
      ).toString();
      let ph = CryptoJS.AES.encrypt(
        vhclmst.user_phone_number.toString(),
        AppConstants.cryptoKey
      ).toString();
      let home = vhclmst.home_address;
      let off = vhclmst.office_address;

      let dateFormat = require("dateformat");
      let now = new Date();
      var myPromise = API.graphql(
        graphqlOperation(AppConstants.UpdateVehicleMaster, {
          id: vhclmst.id,
          driver_id: vhclmst.driver_id,
          vehicle_no: vhclmst.vehicle_no,
          // user_id: vhclmst.user_id,
          user_name: vhclmst.user_name,
          vehicle_model: vhclmst.vehicle_model,
          geofence_limit: vhclmst.geofence_limit,
          user_phone_number: ph,
          notification_flag: vhclmst.notification_flag,
          agency_type: vhclmst.agency_type,
          driver_type: vhclmst.driver_type,
          home_address: {
            elat: hlat,
            elong: hlong,
            address: home,
          },
          office_address: {
            elat: olat,
            elong: olong,
            address: off,
          },
          // created_at:new Date(),
          updated_at: dateFormat(now, "yyyy-mm-dd'T'HH:MM:ss+05:30"),
        })
      ) as Promise<GraphQLResult>;
      myPromise
        .then((result) => {
          console.log("update da vehicle master ", result);
          resolve(
            result.data[
            AppConstants.update +
            AppConstants.env +
            AppConstants.DaVehicleMaster
            ]
          );
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
    return promise;
  }
  // updateVehicleMstStatus(id, status): Promise<any> {
  //   let promise = new Promise((resolve, reject) => {
  //     var that = this;
  //     var myPromise = API.graphql(graphqlOperation(AppConstants.updateVehicleMstStatus, {
  //       id: id,
  //       status: status
  //     })) as Promise<GraphQLResult>
  //     myPromise.then(result => {
  //       resolve(result.data["updateVehicleMaster"])
  //     }).catch(error => {
  //       console.log(error)
  //       reject(error)
  //     })
  //   });
  //   return promise;
  // }

  createVehicleMst(vhclmst): Promise<any> {
    let promise = new Promise((resolve, reject) => {
      var that = this;
      let dateFormat = require("dateformat");
      let now = new Date();
      console.log("vhclmst", vhclmst);

      let hlat = CryptoJS.AES.encrypt(
        vhclmst.home_lat.toString(),
        AppConstants.cryptoKey
      ).toString();
      let hlong = CryptoJS.AES.encrypt(
        vhclmst.home_long.toString(),
        AppConstants.cryptoKey
      ).toString();
      let olat = CryptoJS.AES.encrypt(
        vhclmst.office_lat.toString(),
        AppConstants.cryptoKey
      ).toString();
      let olong = CryptoJS.AES.encrypt(
        vhclmst.office_long.toString(),
        AppConstants.cryptoKey
      ).toString();
      let ph = CryptoJS.AES.encrypt(
        vhclmst.user_phone_number.toString(),
        AppConstants.cryptoKey
      ).toString();

      var myPromise = API.graphql(
        graphqlOperation(AppConstants.createDaVehicleMaster, {
          driver_id: vhclmst.driver_id,
          vehicle_no: vhclmst.vehicle_no,
          user_id: vhclmst.user_id,
          user_name: vhclmst.user_name,
          status: 0,
          vehicle_model: vhclmst.vehicle_model,
          geofence_limit: vhclmst.geofence_limit,
          user_phone_number: ph,
          notification_flag: vhclmst.notification_flag,
          agency_type: vhclmst.agency_type,
          driver_type: vhclmst.driver_type,
          home_address: {
            elat: hlat,
            elong: hlong,
            address: vhclmst.home_address,
          },
          office_address: {
            elat: olat,
            elong: olong,
            address: vhclmst.office_address,
          },
          created_at: dateFormat(now, "yyyy-mm-dd'T'HH:MM:ss+05:30"),
          updated_at: dateFormat(now, "yyyy-mm-dd'T'HH:MM:ss+05:30"),
        })
      ) as Promise<GraphQLResult>;
      myPromise
        .then((result) => {
          resolve(
            result.data[
            AppConstants.create +
            AppConstants.env +
            AppConstants.DaVehicleMaster
            ]
          );
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
    return promise;
  }

  // getTripPositionAllDetails(): Promise<any> {
  //   let promise = new Promise((resolve, reject) => {
  //     var that = this;
  //     var myPromise = API.graphql(graphqlOperation(AppConstants.GetTripPositionAllDetails, { first: 20 })) as Promise<GraphQLResult>
  //     myPromise.then(result => {
  //       resolve(result.data["listTripPositionDetails"].items)
  //     }).catch(error => {
  //       console.log(error)
  //       reject(error)
  //     })
  //   });
  //   return promise;
  // }

  //Get Cab Master by vehicle no and Driver Id
  getScCabMaster(driver_id: String, vehicle_no: String): Promise<any> {
    let promise = new Promise((resolve, reject) => {
      var that = this;
      var myPromise = API.graphql(
        graphqlOperation(AppConstants.GetScCabMaster, {
          driver_id: driver_id,
          vehicle_no: vehicle_no,
        })
      ) as Promise<GraphQLResult>;
      myPromise
        .then((result) => {
          resolve(
            result.data[
              AppConstants.list +
              AppConstants.env +
              AppConstants.listScCabMasters
            ].items
          );
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
    return promise;
  }
  getScCabMasterAll(): Promise<any> {
    let promise = new Promise((resolve, reject) => {
      var that = this;
      var myPromise = API.graphql(
        graphqlOperation(AppConstants.GetScCabMasterAll)
      ) as Promise<GraphQLResult>;
      myPromise
        .then((result) => {
          resolve(
            result.data[
              AppConstants.list +
              AppConstants.env +
              AppConstants.listScCabMasters
            ].items
          );
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
    return promise;
  }
  getScCabMasterById(cab_id: String): Promise<any> {
    let promise = new Promise((resolve, reject) => {
      var that = this;
      var myPromise = API.graphql(
        graphqlOperation(AppConstants.GetScCabMasterById, { id: cab_id })
      ) as Promise<GraphQLResult>;
      myPromise
        .then((result) => {
          // alert(result)
          resolve(
            result.data[
            AppConstants.getq + AppConstants.env + AppConstants.ScCabMaster
            ]
          );
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
    return promise;
  }

  // getScUserTriprById(id: String): Promise<any> {
  //   let promise = new Promise((resolve, reject) => {
  //     var that = this;
  //     var myPromise = API.graphql(graphqlOperation(AppConstants.GetScUserTriprById, { id: id })) as Promise<GraphQLResult>
  //     myPromise.then(result => {
  //       // alert(result)
  //       resolve(result.data[AppConstants.getq + AppConstants.env + AppConstants.ScUserTrip])
  //     }).catch(error => {
  //       console.log(error)
  //       reject(error)
  //     })
  //   });
  //   return promise;
  // }

  // updateVehicleMaster(vhclmst): Promise<any> {
  //   let promise = new Promise((resolve, reject) => {
  //     var that = this;
  //     var myPromise = API.graphql(graphqlOperation(AppConstants.UpdateVehicleMaster, {
  //       id: vhclmst.id,
  //       cab_id: vhclmst.driver_id,
  //       scheduled_date: vhclmst.vehicle_no,
  //       user_id: vhclmst.user_ipin,
  //       user_name: vhclmst.user_name,
  //       vehicle_model: vhclmst.vehicle_model,
  //       geofence_limit: vhclmst.geofence_limit,
  //     })) as Promise<GraphQLResult>
  //     myPromise.then(result => {
  //       resolve(result.data["updateVehicleMaster"])
  //     }).catch(error => {
  //       console.log(error)
  //       reject(error)
  //     })
  //   });
  //   return promise;
  // }
  getScTripMaster(
    driver_id: String,
    cab_id: String,
    trip_type: String,
    scheduled_date: String
  ): Promise<any> {
    let promise = new Promise((resolve, reject) => {
      var that = this;
      var myPromise = API.graphql(
        graphqlOperation(AppConstants.GetScTripMaster, {
          driver_id: driver_id,
          cab_id: cab_id,
          trip_type: trip_type,
          scheduled_date: scheduled_date,
        })
      ) as Promise<GraphQLResult>;
      myPromise
        .then((result) => {
          resolve(
            result.data[
              AppConstants.list +
              AppConstants.env +
              AppConstants.listScTripMasters
            ].items
          );
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
    return promise;
  }

  getScTripMasterFilter(cab_id: String, scheduled_date: String): Promise<any> {
    let promise = new Promise((resolve, reject) => {
      var that = this;
      var q = AppConstants.ListScTripMaster;
      var filter = {};
      if (cab_id != "" && scheduled_date != "") {
        q = AppConstants.ListScTripMasterSchduleCab;
        filter = { scheduled_date: scheduled_date, cab_id: cab_id };
      } else if (cab_id != "") {
        q = AppConstants.ListScTripMasterByCab;
        filter = { cab_id: cab_id };
      } else if (scheduled_date != "") {
        q = AppConstants.ListScTripMasterBySchdule;
        filter = { scheduled_date: scheduled_date };
      } else {
        q = AppConstants.ListScTripMaster;
      }
      console.log("QUERY", q);
      var myPromise = API.graphql(
        graphqlOperation(q, filter)
      ) as Promise<GraphQLResult>;
      myPromise
        .then((result) => {
          resolve(
            result.data[
            AppConstants.list +
            AppConstants.env +
            AppConstants.listScTripMasters
            ]
          );
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
    return promise;
  }

  getScTripMasterFilterNextToken(
    cab_id: String,
    scheduled_date: String,
    nexttoken: String
  ): Promise<any> {
    let promise = new Promise((resolve, reject) => {
      var that = this;
      var q = AppConstants.ListScTripMasterNextToken;
      var filter = {};
      if (cab_id != "" && scheduled_date != "") {
        q = AppConstants.ListScTripMasterSchduleCabNextToken;
        filter = {
          scheduled_date: scheduled_date,
          cab_id: cab_id,
          nextToken: nexttoken,
        };
      } else if (cab_id != "") {
        q = AppConstants.ListScTripMasterByCabNextToken;
        filter = { cab_id: cab_id, nextToken: nexttoken };
      } else if (scheduled_date != "") {
        q = AppConstants.ListScTripMasterBySchduleNextToken;
        filter = { scheduled_date: scheduled_date, nextToken: nexttoken };
      } else {
        q = AppConstants.ListScTripMasterNextToken;
        filter = { nextToken: nexttoken };
      }
      console.log("QUERY", q);
      var myPromise = API.graphql(
        graphqlOperation(q, filter)
      ) as Promise<GraphQLResult>;
      myPromise
        .then((result) => {
          let data = { items: {}, nextToken: String };
          data.items =
            result.data[
              AppConstants.list +
              AppConstants.env +
              AppConstants.listScTripMasters
            ].items;
          data.nextToken =
            result.data[
              AppConstants.list +
              AppConstants.env +
              AppConstants.listScTripMasters
            ].nextToken;

          resolve(data);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
    return promise;
  }

  getScTripMasterByDate(scheduled_date: String): Promise<any> {
    let promise = new Promise((resolve, reject) => {
      var that = this;
      var myPromise = API.graphql(
        graphqlOperation(AppConstants.ListScTripMasterBySchdule, {
          scheduled_date: scheduled_date,
        })
      ) as Promise<GraphQLResult>;
      myPromise
        .then((result) => {
          resolve(
            result.data[
            AppConstants.list +
            AppConstants.env +
            AppConstants.listScTripMasters
            ]
          );
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
    return promise;
  }

  getScTripMasterByDateWithToken(
    scheduled_date: String,
    nextToken: String
  ): Promise<any> {
    let promise = new Promise((resolve, reject) => {
      var that = this;
      var myPromise = API.graphql(
        graphqlOperation(AppConstants.ListScTripMasterBySchduleWithToken, {
          scheduled_date: scheduled_date,
          nextToken: nextToken,
        })
      ) as Promise<GraphQLResult>;
      myPromise
        .then((result) => {
          resolve(
            result.data[
            AppConstants.list +
            AppConstants.env +
            AppConstants.listScTripMasters
            ]
          );
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
    return promise;
  }
  getScTripMasterAll(): Promise<any> {
    let promise = new Promise((resolve, reject) => {
      var that = this;
      var q = AppConstants.ListScTripMaster;
      var filter = {};
      var myPromise = API.graphql(
        graphqlOperation(AppConstants.ListScTripMaster)
      ) as Promise<GraphQLResult>;
      myPromise
        .then((result) => {
          resolve(
            result.data[
            AppConstants.list +
            AppConstants.env +
            AppConstants.listScTripMasters
            ]
          );
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
    return promise;
  }
  getScTripMasterById(id: String): Promise<any> {
    let promise = new Promise((resolve, reject) => {
      var that = this;
      var myPromise = API.graphql(
        graphqlOperation(AppConstants.GetScTripMasterByID, { id: id })
      ) as Promise<GraphQLResult>;
      myPromise
        .then((result) => {
          resolve(
            result.data[
            AppConstants.getq + AppConstants.env + AppConstants.ScTripMaster
            ]
          );
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
    return promise;
  }

  getScSosListAll(): Promise<any> {
    let promise = new Promise((resolve, reject) => {
      var that = this;
      var myPromise = API.graphql(
        graphqlOperation(AppConstants.getScSosList)
      ) as Promise<GraphQLResult>;
      myPromise
        .then((result) => {
          resolve(
            result.data[
              AppConstants.list + AppConstants.env + AppConstants.listScSos
            ].items
          );
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
    return promise;
  }

  /** CAP 18-10-2019 **/

  /* CAR REQUEST */
  getCarRequestListAll(): Promise<any> {
    let promise = new Promise((resolve, reject) => {
      var that = this;
      var myPromise = API.graphql(
        graphqlOperation(AppConstants.getCarRequestListAll)
      ) as Promise<GraphQLResult>;
      myPromise
        .then((result) => {
          resolve(
            result.data[
              AppConstants.list +
              AppConstants.env +
              AppConstants.listCpCarRequest
            ].items
          );
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
    return promise;
  }
  /* ########################## */

  /* ##################### 2019 HOUSE REQUEST ############# */
  // pageCount, pagenationNextToken

  getCarMaintenanceNextTokenPage(nextToken: string, limit: number): Promise<any> {
    return new Promise((resolve, reject) => {
      var myPromise = API.graphql(
        graphqlOperation(AppConstants.getCarMaintenanceNextTokenListAll, {
          nextToken: nextToken,
          limit: limit,
        })
      ) as Promise<GraphQLResult>;

      myPromise
        .then((result) => {
          console.log("Page Result:", result);
          resolve(
            result.data[
            AppConstants.list + AppConstants.env + AppConstants.listCpCarMaintenance
            ]
          );
        })
        .catch((error) => {
          console.log("Error in fetching page:", error);
          reject(error);
        });
    });
  }


  getCarMaintenanceListAll(): Promise<any> {
    let promise = new Promise((resolve, reject) => {
      var that = this;
      var myPromise = API.graphql(
        graphqlOperation(AppConstants.getCarMaintenanceListAll, {
          // limit: pageCount,
          // nextToken: pagenationNextToken,
          // sort: { field: "created_date", direction: "desc" },
        })
      ) as Promise<GraphQLResult>;
      myPromise
        .then((result) => {
          console.log("PRINT", result);
          resolve(
            result.data[
            AppConstants.list +
            AppConstants.env +
            AppConstants.listCpCarMaintenance
            ]
          );
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
    return promise;
  }

  UpdateCarMaintenanceData(CarMaintenance): Promise<any> {
    console.log("-------------------", CarMaintenance);
    let promise = new Promise((resolve, reject) => {
      var that = this;
      var myPromise = API.graphql(
        graphqlOperation(AppConstants.UpdateCarMaintenanceData, {
          id: CarMaintenance.id,
          comments: CarMaintenance.comments,
          request_status: CarMaintenance.request_status,
          ex_data: CarMaintenance.ex_data,
          sla_date: CarMaintenance.sla_date,
        })
      ) as Promise<GraphQLResult>;
      myPromise
        .then((result) => {
          console.log("----result-------", result);
          resolve(
            result.data[
            AppConstants.update +
            AppConstants.env +
            AppConstants.updateCpCarMaintenance
            ]
          );
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
    return promise;
  }
  /* ##################### 2019 HOUSE REQUEST ############# */

  /* ##################### 2019 HOUSE REQUEST ############# */
  getHouseRequestListAll(): Promise<any> {
    let promise = new Promise((resolve, reject) => {
      var that = this;
      var myPromise = API.graphql(
        graphqlOperation(AppConstants.getHouseRequestListAll)
      ) as Promise<GraphQLResult>;
      myPromise
        .then((result) => {
          resolve(
            result.data[
              AppConstants.list +
              AppConstants.env +
              AppConstants.listCpHouseRequest
            ].items
          );
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
    return promise;
  }

  UpdateHouseRequestData(houseReqData): Promise<any> {
    console.log("-------------------", houseReqData);
    let promise = new Promise((resolve, reject) => {
      var that = this;
      var myPromise = API.graphql(
        graphqlOperation(AppConstants.UpdateHouseRequestData, {
          id: houseReqData.id,
          comments: houseReqData.comments,
          request_status: houseReqData.request_status,
          ex_data: houseReqData.ex_data,
          sla_date: houseReqData.sla_date,
        })
      ) as Promise<GraphQLResult>;
      myPromise
        .then((result) => {
          console.log("----result-------", result);
          resolve(
            result.data[
            AppConstants.update +
            AppConstants.env +
            AppConstants.updateCpHouseRequest
            ]
          );
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
    return promise;
  }
  /* ##################### 2019 HOUSE REQUEST ############# */

  /* ##################### 2019 HOUSE RELOCATION REQUEST ############# */
  getHouseReLocationListAll(): Promise<any> {
    let promise = new Promise((resolve, reject) => {
      var that = this;
      var myPromise = API.graphql(
        graphqlOperation(AppConstants.getHouseReLocationListAll)
      ) as Promise<GraphQLResult>;
      myPromise
        .then((result) => {
          resolve(
            result.data[
              AppConstants.list +
              AppConstants.env +
              AppConstants.listCpHouseRelocation
            ].items
          );
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
    return promise;
  }
  UpdateReHouseRequestData(houseReLocData): Promise<any> {
    console.log("-------------------", houseReLocData);
    let promise = new Promise((resolve, reject) => {
      var that = this;
      var myPromise = API.graphql(
        graphqlOperation(AppConstants.UpdateReHouseRequestData, {
          id: houseReLocData.id,
          comments: houseReLocData.comments,
          request_status: houseReLocData.request_status,
          ex_data: houseReLocData.ex_data,
          sla_date: houseReLocData.sla_date,
          packing_Date: houseReLocData.packing_Date,
        })
      ) as Promise<GraphQLResult>;
      myPromise
        .then((result) => {
          console.log("----result-------", result);
          resolve(
            result.data[
            AppConstants.update +
            AppConstants.env +
            AppConstants.updateCpHouseRelocation
            ]
          );
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
    return promise;
  }

  vendorIdFilter(id): Promise<any> {
    let promise = new Promise((resolve, reject) => {
      var that = this;
      var myPromise = API.graphql(
        graphqlOperation(AppConstants.vendorIdFilter, { id: id })
      ) as Promise<GraphQLResult>;
      myPromise
        .then((result) => {
          resolve(
            result.data[
              AppConstants.list +
              AppConstants.env +
              AppConstants.listCpVendorDetail
            ].items
          );
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
    return promise;
  }

  userHouseFilter(id): Promise<any> {
    let promise = new Promise((resolve, reject) => {
      var that = this;
      var myPromise = API.graphql(
        graphqlOperation(AppConstants.userHouseFilter, { id: id })
      ) as Promise<GraphQLResult>;
      myPromise
        .then((result) => {
          resolve(
            result.data[
              AppConstants.list +
              AppConstants.env +
              AppConstants.listCpHouseMaster
            ].items
          );
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
    return promise;
  }

  singleHouseData(id): Promise<any> {
    let promise = new Promise((resolve, reject) => {
      var that = this;
      var myPromise = API.graphql(
        graphqlOperation(AppConstants.singleHouseData, { id: id })
      ) as Promise<GraphQLResult>;
      myPromise
        .then((result) => {
          resolve(
            result.data[
              AppConstants.list +
              AppConstants.env +
              AppConstants.listCpHouseRequest
            ].items
          );
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
    return promise;
  }

  singleHouseRelocationData(id): Promise<any> {
    let promise = new Promise((resolve, reject) => {
      var that = this;
      var myPromise = API.graphql(
        graphqlOperation(AppConstants.singleHouseRelocationData, { id: id })
      ) as Promise<GraphQLResult>;
      myPromise
        .then((result) => {
          resolve(
            result.data[
              AppConstants.list +
              AppConstants.env +
              AppConstants.listCpHouseRelocation
            ].items
          );
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
    return promise;
  }

  singleCarData(id): Promise<any> {
    let promise = new Promise((resolve, reject) => {
      var that = this;
      var myPromise = API.graphql(
        graphqlOperation(AppConstants.singleCarData, { id: id })
      ) as Promise<GraphQLResult>;
      myPromise
        .then((result) => {
          resolve(
            result.data[
              AppConstants.list +
              AppConstants.env +
              AppConstants.listCpCarMaintenance
            ].items
          );
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
    return promise;
  }
  /* ##################### 2019 HOUSE RELOCATION REQUEST ############# */

  filterCarRecord(carReqData) {
    console.log("FILTER_CAR_DATA", carReqData);
    let promise = new Promise((resolve, reject) => {
      var that = this;
      var myPromise = API.graphql(
        graphqlOperation(AppConstants.filterCarRecord, { id: carReqData })
      ) as Promise<GraphQLResult>;
      myPromise
        .then((result) => {
          resolve(
            result.data[
              AppConstants.list +
              AppConstants.env +
              AppConstants.listCpVehicleMaster
            ].items
          );
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
    return promise;
  }
  /* ############################# */

  UpdateCarRequestData(carReqData): Promise<any> {
    console.log("-------------------", carReqData);
    let promise = new Promise((resolve, reject) => {
      var that = this;
      var myPromise = API.graphql(
        graphqlOperation(AppConstants.UpdateCarRequestData, {
          id: carReqData.id,
          car_id: carReqData.car_id,
          comments: carReqData.comments,
          request_status: carReqData.request_status,
          car_status: carReqData.car_status,
        })
      ) as Promise<GraphQLResult>;
      myPromise
        .then((result) => {
          console.log("----result-------", result);
          console.log(
            AppConstants.update +
            AppConstants.env +
            AppConstants.updateCpCarRequest
          );
          resolve(
            result.data[
            AppConstants.update +
            AppConstants.env +
            AppConstants.updateCpCarRequest
            ]
          );
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
    return promise;
  }

  /* USER CAR ALLOCATION TO ASSIGN CAR TABLE */
  UpdateUserIdCarMaster(data): Promise<any> {
    console.log("-------------------", data);
    let promise = new Promise((resolve, reject) => {
      var that = this;
      var myPromise = API.graphql(
        graphqlOperation(AppConstants.UpdateUserIdCarMaster, {
          id: data.car_id,
          map_user_id: data.id,
        })
      ) as Promise<GraphQLResult>;
      myPromise
        .then((result) => {
          console.log(
            AppConstants.update +
            AppConstants.env +
            AppConstants.updateCpVehicleMaster
          );
          resolve(
            result.data[
            AppConstants.update +
            AppConstants.env +
            AppConstants.updateCpVehicleMaster
            ]
          );
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
    return promise;
  }
  getCarfilterList(): Promise<any> {
    let promise = new Promise((resolve, reject) => {
      var that = this;
      var myPromise = API.graphql(
        graphqlOperation(AppConstants.getCarfilterList)
      ) as Promise<GraphQLResult>;
      myPromise
        .then((result) => {
          resolve(
            result.data[
              AppConstants.list +
              AppConstants.env +
              AppConstants.listCpVehicleMaster
            ].items
          );
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
    return promise;
  }
  /* USER CAR ALLOCATION TO ASSIGN CAR TABLE */
  /* ############### CAR MODULE ##################### */
  getCarListAll(): Promise<any> {
    let promise = new Promise((resolve, reject) => {
      var that = this;
      var myPromise = API.graphql(
        graphqlOperation(AppConstants.getCarListAll)
      ) as Promise<GraphQLResult>;
      myPromise
        .then((result) => {
          resolve(
            result.data[
              AppConstants.list +
              AppConstants.env +
              AppConstants.listCpVehicleMaster
            ].items
          );
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
    return promise;
  }
  UpdateCarData(carData): Promise<any> {
    console.log("-------------------", carData);
    let promise = new Promise((resolve, reject) => {
      var that = this;
      var myPromise = API.graphql(
        graphqlOperation(AppConstants.UpdateCarData, {
          id: carData.id,
          car_model: carData.car_model,
          veh_reg_id: carData.veh_reg_id,
          policy_no: carData.policy_no,
          policy_from: carData.policy_from,
          policy_to: carData.policy_to,
          agency_name: carData.agency_name,
          map_user_id: carData.map_user_id,
          lease_from: carData.lease_from,
          lease_to: carData.lease_to,
        })
      ) as Promise<GraphQLResult>;
      myPromise
        .then((result) => {
          console.log("result", result);
          console.log(
            AppConstants.update +
            AppConstants.env +
            AppConstants.updateCpVehicleMaster
          );
          resolve(
            result.data[
            AppConstants.update +
            AppConstants.env +
            AppConstants.updateCpVehicleMaster
            ]
          );
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
    return promise;
  }
  CreateCarData(carData): Promise<any> {
    console.log("-------------------", carData);
    let promise = new Promise((resolve, reject) => {
      var that = this;
      var myPromise = API.graphql(
        graphqlOperation(AppConstants.CreateCarData, {
          id: carData.id,
          car_model: carData.car_model,
          veh_reg_id: carData.veh_reg_id,
          policy_no: carData.policy_no,
          policy_from: carData.policy_from,
          policy_to: carData.policy_to,
          agency_name: carData.agency_name,
          map_user_id: 0,
          lease_from: carData.lease_from,
          lease_to: carData.lease_to,
          car_type: 0,
          ex_data: "UNASSIGN",
        })
      ) as Promise<GraphQLResult>;
      myPromise
        .then((result) => {
          console.log("result", result);
          console.log(
            AppConstants.create +
            AppConstants.env +
            AppConstants.updateCpVehicleMaster
          );
          resolve(
            result.data[
            AppConstants.create +
            AppConstants.env +
            AppConstants.updateCpVehicleMaster
            ]
          );
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
    return promise;
  }

  deleteCarData(id: String): Promise<any> {
    let promise = new Promise((resolve, reject) => {
      var myPromise = API.graphql(
        graphqlOperation(AppConstants.deleteCarData, { id: id })
      ) as Promise<GraphQLResult>;
      var that = this;
      myPromise
        .then((result) => {
          resolve(
            result.data[
            AppConstants.delete +
            AppConstants.env +
            AppConstants.updateCpVehicleMaster
            ]
          );
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
    return promise;
  }

  /** CAP 18-10-2019 **/
  /* ############### CAR MODULE ##################### */

  /* ############## CAR ASSIGNED MODULE ################ */
  //nextToken: string, limit: number
  // nextToken: nextToken,
  // limit: limit,
  filterRnCar(): Promise<any> {
    let promise = new Promise((resolve, reject) => {
      var that = this;
      var myPromise = API.graphql(
        graphqlOperation(AppConstants.filterRnCar, {
          ex_data: "UNASSIGN",

        })
      ) as Promise<GraphQLResult>;
      myPromise
        .then((result) => {
          console.log("456123", result);
          resolve(
            result.data[
              AppConstants.list +
              AppConstants.env +
              AppConstants.listCpVehicleMaster
            ].items
          );
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
    return promise;
  }

  filterRnExistCar(rn_id: String): Promise<any> {
    let promise = new Promise((resolve, reject) => {
      var that = this;
      var myPromise = API.graphql(
        graphqlOperation(AppConstants.filterRnExistCar, { rn_id: rn_id })
      ) as Promise<GraphQLResult>;
      myPromise
        .then((result) => {
          //  console.log(AppConstants.list + AppConstants.env + AppConstants.RncUsers)
          resolve(
            result.data[
              AppConstants.list +
              AppConstants.env +
              AppConstants.listCpAssignedCar
            ].items
          );
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
    return promise;
  }

  getAssignCarList(): Promise<any> {
    let promise = new Promise((resolve, reject) => {
      var that = this;
      var myPromise = API.graphql(
        graphqlOperation(AppConstants.getAssignCarList)
      ) as Promise<GraphQLResult>;
      myPromise
        .then((result) => {
          resolve(
            result.data[
              AppConstants.list +
              AppConstants.env +
              AppConstants.listCpAssignedCar
            ].items
          );
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
    return promise;
  }

  getCarListFilterAll(): Promise<any> {
    let promise = new Promise((resolve, reject) => {
      var that = this;
      var myPromise = API.graphql(
        graphqlOperation(AppConstants.getCarListFilterAll)
      ) as Promise<GraphQLResult>;
      myPromise
        .then((result) => {
          resolve(
            result.data[
              AppConstants.list +
              AppConstants.env +
              AppConstants.listCpVehicleMaster
            ].items
          );
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
    return promise;
  }

  CreateAssignCar(carData): Promise<any> {
    console.log("-------------------", carData);
    let promise = new Promise((resolve, reject) => {
      var that = this;
      var myPromise = API.graphql(
        graphqlOperation(AppConstants.CreateAssignCar, {
          user_pid: carData.user_pid,
          rn_id: carData.rn_id,
          car_id: carData.car_id,
          assigned_date: carData.assigned_date,
          // end_date: carData.end_date,
          status: carData.status,
          ex_data: carData.ex_data,
          fuel_card_id: carData.fuel_card_id
        })
      ) as Promise<GraphQLResult>;
      myPromise
        .then((result) => {
          console.log("result-aws-services", result);
          resolve(
            result.data[
            AppConstants.create +
            AppConstants.env +
            AppConstants.updateCpAssignedCar
            ]
          );
          // resolve(result.data)
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
    return promise;
  }

  updateAssignCar(carData): Promise<any> {
    console.log("-------------------", carData);
    let promise = new Promise((resolve, reject) => {
      var that = this;
      var myPromise = API.graphql(
        graphqlOperation(AppConstants.updateAssignCar, {
          id: carData.id,
          rn_id: carData.rn_id,
          car_id: carData.car_id,
          assigned_date: carData.assigned_date,
          end_date: carData.end_date,
          status: carData.status,
          ex_data: carData.car_type,
        })
      ) as Promise<GraphQLResult>;
      myPromise
        .then((result) => {
          console.log("result", result);
          resolve(
            result.data[
            AppConstants.update +
            AppConstants.env +
            AppConstants.updateCpAssignedCar
            ]
          );
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
    return promise;
  }

  carIdFilter(id): Promise<any> {
    let promise = new Promise((resolve, reject) => {
      var that = this;
      var myPromise = API.graphql(
        graphqlOperation(AppConstants.carIdFilter, { id: id })
      ) as Promise<GraphQLResult>;
      myPromise
        .then((result) => {
          resolve(
            result.data[
              AppConstants.list +
              AppConstants.env +
              AppConstants.listCpVehicleMaster
            ].items
          );
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
    return promise;
  }

  updateMasterCar(carData): Promise<any> {
    console.log("-------------------", carData);
    let promise = new Promise((resolve, reject) => {
      var that = this;
      var myPromise = API.graphql(
        graphqlOperation(AppConstants.updateMasterCar, {
          id: carData.car_id,
          ex_data: carData.status,
        })
      ) as Promise<GraphQLResult>;
      myPromise
        .then((result) => {
          console.log("result", result);
          resolve(
            result.data[
            AppConstants.update +
            AppConstants.env +
            AppConstants.updateCpVehicleMaster
            ]
          );
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
    return promise;
  }


  updateFuelCardStatus(updateCard): Promise<any> {
    let promise = new Promise((resolve, reject) => {
      var that = this;
      var myPromise = API.graphql(
        graphqlOperation(AppConstants.updateFuelCardMaster, {
          id: updateCard.fuel_card_id,
          status: updateCard.status,
          updated_date: new Date().toISOString(),
        })
      ) as Promise<GraphQLResult>;
      myPromise
        .then((result) => {
          console.log("result", result);
          resolve(
            result.data[
            AppConstants.update +
            AppConstants.env +
            AppConstants.FuelMasterCard
            ]
          );
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
    return promise;
  }

  /* ############## CAR ASSIGNED MODULE ################ */

  /* ############## ASSIGN USER ####################### */

  sendEmailService(data) {
    let basUrl = "https://safecab-sms.rntbciconnect.com/";
    return this.httpClient.post(basUrl + "assignUserEmail/", { ...data });
  }
  userAssignData(userData): Promise<any> {
    console.log("-------------------", userData);
    let promise = new Promise((resolve, reject) => {
      var that = this;
      var myPromise = API.graphql(
        graphqlOperation(AppConstants.userAssignData, {
          id: userData.id,
          user_name: userData.user_name,
          name: userData.name,
          email: userData.email,
          phone: userData.phone,
          assign_mode: userData.assign_mode,
          status: userData.status,
          ex_data: userData.country,
          updated_date: new Date().toISOString(),
        })
      ) as Promise<GraphQLResult>;
      myPromise
        .then((result) => {
          console.log("result", result);
          resolve(
            result.data[
            AppConstants.update +
            AppConstants.env +
            AppConstants.updateCpRnUser
            ]
          );
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
    return promise;
  }

  CreateUserAssign(userData): Promise<any> {
    console.log("-------------------", userData);
    let promise = new Promise((resolve, reject) => {
      var that = this;
      var myPromise = API.graphql(
        graphqlOperation(AppConstants.CreateUserAssign, {
          user_name: userData.user_name,
          name: userData.name,
          email: userData.email,
          phone: userData.phone,
          assign_mode: userData.assign_mode,
          status: userData.status,
          ex_data: userData.country,
          created_date: new Date().toISOString(),
          updated_date: new Date().toISOString(),
        })
      ) as Promise<GraphQLResult>;
      myPromise
        .then((result) => {
          console.log("result-aws-services", result);
          resolve(
            result.data[
            AppConstants.create +
            AppConstants.env +
            AppConstants.updateCpRnUser
            ]
          );
          // resolve(result.data)
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
    return promise;
  }

  filterRnUserExist(user_name: String): Promise<any> {
    let promise = new Promise((resolve, reject) => {
      var that = this;
      var myPromise = API.graphql(
        graphqlOperation(AppConstants.filterRnUserExist, {
          user_name: user_name,
        })
      ) as Promise<GraphQLResult>;
      myPromise
        .then((result) => {
          //  console.log(AppConstants.list + AppConstants.env + AppConstants.RncUsers)
          resolve(
            result.data[
              AppConstants.list + AppConstants.env + AppConstants.listCpRnUser
            ].items
          );
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
    return promise;
  }

  getAssignUserList(): Promise<any> {
    let promise = new Promise((resolve, reject) => {
      var that = this;
      var myPromise = API.graphql(
        graphqlOperation(AppConstants.getAssignUserList)
      ) as Promise<GraphQLResult>;
      myPromise
        .then((result) => {
          resolve(
            result.data[
              AppConstants.list + AppConstants.env + AppConstants.listCpRnUser
            ].items
          );
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
    return promise;
  }
  /* ############## ASSIGN USER ####################### */

  /* ################ ASSIGNED HOUSE ################# */
  assignHomeFilter(rn_id: String): Promise<any> {
    let promise = new Promise((resolve, reject) => {
      var that = this;
      var myPromise = API.graphql(
        graphqlOperation(AppConstants.assignHomeFilter, { rn_id: rn_id })
      ) as Promise<GraphQLResult>;
      myPromise
        .then((result) => {
          //  console.log(AppConstants.list + AppConstants.env + AppConstants.RncUsers)
          resolve(
            result.data[
              AppConstants.list +
              AppConstants.env +
              AppConstants.listCpAssignedHome
            ].items
          );
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
    return promise;
  }
  rnUserFilter(user_name: String): Promise<any> {
    let promise = new Promise((resolve, reject) => {
      var that = this;
      var myPromise = API.graphql(
        graphqlOperation(AppConstants.rnUserFilter, { user_name: user_name })
      ) as Promise<GraphQLResult>;
      myPromise
        .then((result) => {
          //  console.log(AppConstants.list + AppConstants.env + AppConstants.RncUsers)
          resolve(
            result.data[
              AppConstants.list + AppConstants.env + AppConstants.RncUsers
            ].items
          );
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
    return promise;
  }

  CreateAssignHouse(houseData): Promise<any> {
    console.log("-------------------", houseData);
    let promise = new Promise((resolve, reject) => {
      var that = this;
      var myPromise = API.graphql(
        graphqlOperation(AppConstants.CreateAssignHouse, {
          user_pid: houseData.user_pid,
          rn_id: houseData.rn_id,
          home_id: houseData.home_id,
          assigned_date: houseData.assigned_date,
          // end_date: houseData.end_date,
          status: houseData.status,
          ex_data: houseData.ex_data,
        })
      ) as Promise<GraphQLResult>;
      myPromise
        .then((result) => {
          console.log("result-aws-services", result);
          resolve(
            result.data[
            AppConstants.create +
            AppConstants.env +
            AppConstants.updateCpAssignedHome
            ]
          );
          // resolve(result.data)
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
    return promise;
  }

  getAssignHouseList(): Promise<any> {
    let promise = new Promise((resolve, reject) => {
      var that = this;
      var myPromise = API.graphql(
        graphqlOperation(AppConstants.getAssignHouseList)
      ) as Promise<GraphQLResult>;
      myPromise
        .then((result) => {
          resolve(
            result.data[
              AppConstants.list +
              AppConstants.env +
              AppConstants.listCpAssignedHome
            ].items
          );
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
    return promise;
  }

  homeIdFilter(id): Promise<any> {
    let promise = new Promise((resolve, reject) => {
      var that = this;
      var myPromise = API.graphql(
        graphqlOperation(AppConstants.homeIdFilter, { id: id })
      ) as Promise<GraphQLResult>;
      myPromise
        .then((result) => {
          resolve(
            result.data[
              AppConstants.list +
              AppConstants.env +
              AppConstants.listCpHouseMaster
            ].items
          );
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
    return promise;
  }

  updateAssignHouse(houseData): Promise<any> {
    console.log("-------------------", houseData);
    let promise = new Promise((resolve, reject) => {
      var that = this;
      var myPromise = API.graphql(
        graphqlOperation(AppConstants.updateAssignHouse, {
          id: houseData.id,
          rn_id: houseData.rn_id,
          home_id: houseData.home_id,
          assigned_date: houseData.assigned_date,
          end_date: houseData.end_date,
          status: houseData.status,
        })
      ) as Promise<GraphQLResult>;
      myPromise
        .then((result) => {
          console.log("result", result);
          resolve(
            result.data[
            AppConstants.update +
            AppConstants.env +
            AppConstants.updateCpAssignedHome
            ]
          );
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
    return promise;
  }

  updateMasterHouse(houseData): Promise<any> {
    console.log("-------------------", houseData);
    let promise = new Promise((resolve, reject) => {
      var that = this;
      var myPromise = API.graphql(
        graphqlOperation(AppConstants.updateMasterHouse, {
          id: houseData.home_id,
          house_exdata: houseData.status,
        })
      ) as Promise<GraphQLResult>;
      myPromise
        .then((result) => {
          console.log("result", result);
          resolve(
            result.data[
            AppConstants.update +
            AppConstants.env +
            AppConstants.updateCpHouseMaster
            ]
          );
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
    return promise;
  }
  /* ################ ASSIGNED HOUSE ################# */

  /* ############### HOUSE MODULE ################### */

  getUnAssignHouseList(): Promise<any> {
    let promise = new Promise((resolve, reject) => {
      var that = this;
      var myPromise = API.graphql(
        graphqlOperation(AppConstants.getUnAssignHouseList, {
          house_exdata: "UNASSIGN",
        })
      ) as Promise<GraphQLResult>;
      myPromise
        .then((result) => {
          console.log("result7777777777777777777777777", result);
          resolve(
            result.data[
              AppConstants.list +
              AppConstants.env +
              AppConstants.listCpHouseMaster
            ].items
          );
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
    return promise;
  }
  getHouseList(): Promise<any> {
    let promise = new Promise((resolve, reject) => {
      var that = this;
      var myPromise = API.graphql(
        graphqlOperation(AppConstants.getHouseList)
      ) as Promise<GraphQLResult>;
      myPromise
        .then((result) => {
          resolve(
            result.data[
              AppConstants.list +
              AppConstants.env +
              AppConstants.listCpHouseMaster
            ].items
          );
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
    return promise;
  }
  CreateHouseData(houseData): Promise<any> {
    console.log(
      "------------------- aws service createHouseData input: ",
      houseData
    );
    let promise = new Promise((resolve, reject) => {
      var that = this;
      var dtdata = new Date();
      var date_time = dtdata.getDate;
      var myPromise = API.graphql(
        graphqlOperation(AppConstants.CreateHouseData, {
          house_address: houseData.house_address,
          house_location: houseData.house_location,
          house_city: houseData.house_city,
          house_type: houseData.house_type,
          house_size:
            houseData.house_size === undefined || houseData.house_size === ""
              ? "0"
              : houseData.house_size,
          house_exdata:
            houseData.house_exdata === undefined ||
              houseData.house_exdata === ""
              ? "UNASSIGN"
              : houseData.house_exdata,
          owner_name: houseData.owner_name,
          owner_email: houseData.owner_email,
          owner_phone: houseData.owner_phone,
          owner_address: houseData.owner_address,
          owner_exdata:
            houseData.owner_exdata === undefined ||
              houseData.owner_exdata === ""
              ? "0"
              : houseData.owner_exdata,
          lease_start_date: houseData.lease_start_date,
          lease_end_date: houseData.lease_end_date,
          property_type:
            houseData.property_type === undefined ||
              houseData.property_type === ""
              ? "0"
              : houseData.property_type,
          created_date: new Date().toISOString(),
          updated_date: new Date().toISOString(),
        })
      ) as Promise<GraphQLResult>;
      myPromise
        .then((result) => {
          console.log("aws service createHouseData result", result);
          resolve(
            result.data[
            AppConstants.create +
            AppConstants.env +
            AppConstants.updateCpHouseMaster
            ]
          );
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
    return promise;
  }

  UpdateHouseData(houseData): Promise<any> {
    console.log("-------------------", houseData);
    let promise = new Promise((resolve, reject) => {
      var that = this;
      var myPromise = API.graphql(
        graphqlOperation(AppConstants.UpdateHouseData, {
          id: houseData.id,
          house_address: houseData.house_address,
          house_location: houseData.house_location,
          house_city: houseData.house_city,
          house_type: houseData.house_type,
          house_size:
            houseData.house_size === undefined || houseData.house_size === ""
              ? "0"
              : houseData.house_size,
          owner_name: houseData.owner_name,
          owner_email: houseData.owner_email,
          owner_phone: houseData.owner_phone,
          owner_address: houseData.owner_address,
          owner_exdata:
            houseData.owner_exdata === undefined ||
              houseData.owner_exdata === ""
              ? "0"
              : houseData.owner_exdata,
          lease_start_date: houseData.lease_start_date,
          lease_end_date: houseData.lease_end_date,
          property_type: houseData.property_type,
          updated_date: new Date().toISOString(),
        })
      ) as Promise<GraphQLResult>;
      myPromise
        .then((result) => {
          console.log("result", result);
          resolve(
            result.data[
            AppConstants.update +
            AppConstants.env +
            AppConstants.updateCpHouseMaster
            ]
          );
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
    return promise;
  }

  deleteHouseData(id: String): Promise<any> {
    let promise = new Promise((resolve, reject) => {
      var myPromise = API.graphql(
        graphqlOperation(AppConstants.deleteHouseData, { id: id })
      ) as Promise<GraphQLResult>;
      var that = this;
      myPromise
        .then((result) => {
          resolve(
            result.data[
            AppConstants.delete +
            AppConstants.env +
            AppConstants.updateCpHouseMaster
            ]
          );
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
    return promise;
  }

  /* ############### HOUSE MODULE ################### */

  /* ############## VENDOR MODULE ################### */
  getVendorlist(): Promise<any> {
    let promise = new Promise((resolve, reject) => {
      var that = this;
      var myPromise = API.graphql(
        graphqlOperation(AppConstants.getVendorlist)
      ) as Promise<GraphQLResult>;
      myPromise
        .then((result) => {
          resolve(
            result.data[
              AppConstants.list +
              AppConstants.env +
              AppConstants.listCpVendorDetail
            ].items
          );
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
    return promise;
  }

  getActiveVendorlist(): Promise<any> {
    let promise = new Promise((resolve, reject) => {
      var that = this;
      var myPromise = API.graphql(
        graphqlOperation(AppConstants.getActiveVendorlist)
      ) as Promise<GraphQLResult>;
      myPromise
        .then((result) => {
          resolve(
            result.data[
              AppConstants.list +
              AppConstants.env +
              AppConstants.listCpVendorDetail
            ].items
          );
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
    return promise;
  }

  CreateVendorData(vendorData): Promise<any> {
    // console.log("-------------------", vendorData);
    let promise = new Promise((resolve, reject) => {
      var that = this;
      var dtdata = new Date();
      var date_time = dtdata.getDate;
      var myPromise = API.graphql(
        graphqlOperation(AppConstants.CreateVendorData, {
          name: vendorData.name,
          email: vendorData.email,
          phone: vendorData.phone,
          address: vendorData.address,
          vendor_type: vendorData.vendor_type,
          is_active: vendorData.is_active,
          ex_data: vendorData.selectedCountries,
          created_date: new Date().toISOString(),
          updated_date: new Date().toISOString(),
        })
      ) as Promise<GraphQLResult>;
      myPromise
        .then((result) => {
          console.log("result", result);
          resolve(
            result.data[
            AppConstants.update +
            AppConstants.env +
            AppConstants.updateCpVendorDetail
            ]
          );
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
    return promise;
  }

  UpdateVendorData(vendorData): Promise<any> {
    // console.log("-------------------", vendorData);
    let promise = new Promise((resolve, reject) => {
      var that = this;
      var dtdata = new Date();
      var date_time = dtdata.getDate;
      var myPromise = API.graphql(
        graphqlOperation(AppConstants.UpdateVendorData, {
          id: vendorData.id,
          name: vendorData.name,
          email: vendorData.email,
          phone: vendorData.phone,
          address: vendorData.address,
          vendor_type: vendorData.vendor_type,
          is_active: vendorData.is_active,
          ex_data: vendorData.selectedCountries,
          updated_date: new Date().toISOString(),
        })
      ) as Promise<GraphQLResult>;
      myPromise
        .then((result) => {
          console.log("result", result);
          resolve(
            result.data[
            AppConstants.update +
            AppConstants.env +
            AppConstants.updateCpVendorDetail
            ]
          );
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
    return promise;
  }

  deleteVendorData(id: String): Promise<any> {
    let promise = new Promise((resolve, reject) => {
      var myPromise = API.graphql(
        graphqlOperation(AppConstants.deleteVendorData, { id: id })
      ) as Promise<GraphQLResult>;
      var that = this;
      myPromise
        .then((result) => {
          resolve(
            result.data[
            AppConstants.delete +
            AppConstants.env +
            AppConstants.updateCpVendorDetail
            ]
          );
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
    return promise;
  }
  /* ############## VENDOR MODULE ################### */

  // to get wellness app data
  getWelnessData(in_time, to_date): Promise<any> {
    let promise = new Promise((resolve, reject) => {
      var that = this;
      var myPromise = API.graphql(
        graphqlOperation(AppConstants.getAppFitnessFeedback, {
          in_time: in_time,
          to_date: to_date,
        })
      ) as Promise<GraphQLResult>;
      myPromise
        .then((result) => {
          resolve(
            result.data[
            AppConstants.list +
            AppConstants.env +
            AppConstants.listAppFitnessFeedback
            ]
          );
          console.log("getWelnessData", result);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
    return promise;
  }

  // to get wellness app data
  getWelnessDataMigration(): Promise<any> {
    let promise = new Promise((resolve, reject) => {
      var that = this;
      var myPromise = API.graphql(
        graphqlOperation(AppConstants.getAppFitnessFeedbackMigration)
      ) as Promise<GraphQLResult>;
      myPromise
        .then((result) => {
          resolve(
            result.data[
            AppConstants.list +
            AppConstants.env +
            AppConstants.listAppFitnessFeedback
            ]
          );
          console.log("getWelnessData", result);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
    return promise;
  }

  // to get wellness app data
  getWelnessDataNextTokenMigration(nextToken): Promise<any> {
    let promise = new Promise((resolve, reject) => {
      var that = this;

      var myPromise = API.graphql(
        graphqlOperation(AppConstants.getAppFitnessFeedbackNextTokenMigration, {
          nextToken: nextToken,
        })
      ) as Promise<GraphQLResult>;
      myPromise
        .then((result) => {
          resolve(
            result.data[
            AppConstants.list +
            AppConstants.env +
            AppConstants.listAppFitnessFeedback
            ]
          );
          console.log("getWelnessDataNextToken", result);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
    return promise;
  }

  // to get wellness app data
  getWelnessDataNextToken(nextToken, in_time, to_date): Promise<any> {
    let promise = new Promise((resolve, reject) => {
      var that = this;

      var myPromise = API.graphql(
        graphqlOperation(AppConstants.getAppFitnessFeedbackNextToken, {
          nextToken: nextToken,
          in_time: in_time,
          to_date: to_date,
        })
      ) as Promise<GraphQLResult>;
      myPromise
        .then((result) => {
          resolve(
            result.data[
            AppConstants.list +
            AppConstants.env +
            AppConstants.listAppFitnessFeedback
            ]
          );
          console.log("getWelnessDataNextToken", result);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
    return promise;
  }

  getOpenSos(): Promise<any> {
    let promise = new Promise((resolve, reject) => {
      var that = this;
      var myPromise = API.graphql(
        graphqlOperation(AppConstants.getOpenSos)
      ) as Promise<GraphQLResult>;
      myPromise
        .then((result) => {
          resolve(
            result.data[
              AppConstants.list + AppConstants.env + AppConstants.listScSos
            ].items
          );
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
    return promise;
  }
  getScSosList(): Promise<any> {
    let promise = new Promise((resolve, reject) => {
      var that = this;
      var myPromise = API.graphql(
        graphqlOperation(AppConstants.getScSosListCnt)
      ) as Promise<GraphQLResult>;
      myPromise
        .then((result) => {
          resolve(
            result.data[
              AppConstants.list + AppConstants.env + AppConstants.listScSos
            ].items
          );
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
    return promise;
  }
  getScSosMaster(): Promise<any> {
    let promise = new Promise((resolve, reject) => {
      var that = this;
      var myPromise = API.graphql(
        graphqlOperation(AppConstants.getScSosMaster)
      ) as Promise<GraphQLResult>;
      myPromise
        .then((result) => {
          resolve(
            result.data[
              AppConstants.list +
              AppConstants.env +
              AppConstants.listScSosMasters
            ].items
          );
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
    return promise;
  }
  UpdateScSos(sos): Promise<any> {
    let promise = new Promise((resolve, reject) => {
      var that = this;
      var myPromise = API.graphql(
        graphqlOperation(AppConstants.UpdateScSOS, {
          id: sos.id,
          comments: sos.comments,
          status: sos.status,
        })
      ) as Promise<GraphQLResult>;
      myPromise
        .then((result) => {
          console.log("result", result);
          console.log(
            AppConstants.update + AppConstants.env + AppConstants.ScSos
          );
          resolve(
            result.data[
            AppConstants.update + AppConstants.env + AppConstants.ScSos
            ]
          );
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
    return promise;
  }
  UpdateScTripMaster(trip): Promise<any> {
    let promise = new Promise((resolve, reject) => {
      var that = this;
      var myPromise = API.graphql(
        graphqlOperation(AppConstants.UpdateScTripMaster, {
          id: trip.id,
          driver_id: trip.driver_id,
          scheduled_date:
            trip.scheduled_date + "T" + trip.scheduled_time + ":00+05:30",
          cab_id: trip.cab_id,
          status: trip.status,
          trip_type: trip.trip_type,
        })
      ) as Promise<GraphQLResult>;
      myPromise
        .then((result) => {
          resolve(
            result.data[
            AppConstants.update + AppConstants.env + AppConstants.ScTripMaster
            ]
          );
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
    return promise;
  }

  UpdateScUserByTrip(id, usertrip): Promise<any> {
    let promise = new Promise((resolve, reject) => {
      var that = this;
      var myPromise = API.graphql(
        graphqlOperation(AppConstants.UpdateScUserByTrip, {
          id: id,
          scheduled_date:
            usertrip.scheduled_date +
            "T" +
            usertrip.scheduled_time +
            ":00+05:30",
          trip_type: usertrip.trip_type,
        })
      ) as Promise<GraphQLResult>;
      myPromise
        .then((result) => {
          resolve(
            result.data[
            AppConstants.update + AppConstants.env + AppConstants.ScUserTrip
            ]
          );
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
    return promise;
  }

  // updateSos(sos): Promise<any> {
  //   let promise = new Promise((resolve, reject) => {
  //     var that = this;
  //     var myPromise = API.graphql(graphqlOperation(AppConstants.UpdateSOS,
  //       {
  //         id: sos.id,
  //         admin_comment: sos.admin_comment
  //       })) as Promise<GraphQLResult>
  //     myPromise.then(result => {
  //       resolve(result.data["UpdateSOS"])
  //     }).catch(error => {
  //       console.log(error)
  //       reject(error)
  //     })
  //   });
  //   return promise;
  // }

  // creaet SC_
  UpdateScUserTrips(usertrip, st, end): Promise<any> {
    let promise = new Promise((resolve, reject) => {
      var that = this;

      var myPromise = API.graphql(
        graphqlOperation(AppConstants.UpdateScUserTrips, {
          id: usertrip.id,
          trip_status: usertrip.trip_status,
          drop_point: usertrip.drop_point,
          otp: usertrip.otp,
          is_boarded: usertrip.is_boarded,
          start_address: {
            lat: st.lat,
            long: st.long,
            address: st.address,
          },
          end_address: {
            lat: end.lat,
            long: end.long,
            address: end.address,
          },
        })
      ) as Promise<GraphQLResult>;
      myPromise
        .then((result) => {
          resolve(
            result.data[
            AppConstants.update + AppConstants.env + AppConstants.ScUserTrip
            ]
          );
        })
        .catch((error) => {
          reject(error);
        });
    });
    return promise;
  }

  UpdateScUserTripsOtp(id): Promise<any> {
    let promise = new Promise((resolve, reject) => {
      var that = this;

      var myPromise = API.graphql(
        graphqlOperation(AppConstants.UpdateScUserTripsOtp, {
          id: id,
          otp: 123456,
        })
      ) as Promise<GraphQLResult>;
      myPromise
        .then((result) => {
          resolve(
            result.data[
            AppConstants.update + AppConstants.env + AppConstants.ScUserTrip
            ]
          );
        })
        .catch((error) => {
          reject(error);
        });
    });
    return promise;
  }
  // creaet SC_
  updateScUserTrip(id, start, end): Promise<any> {
    let promise = new Promise((resolve, reject) => {
      var that = this;

      var myPromise = API.graphql(
        graphqlOperation(AppConstants.UpdateScUserTripAddress, {
          id: id,
          start_address: {
            lat: start.lat,
            long: start.long,
            address: start.address,
          },
          end_address: {
            lat: end.lat,
            long: end.long,
            address: end.address,
          },
        })
      ) as Promise<GraphQLResult>;
      myPromise
        .then((result) => {
          resolve(
            result.data[
            AppConstants.update + AppConstants.env + AppConstants.ScUserTrip
            ]
          );
        })
        .catch((error) => {
          reject(error);
        });
    });
    return promise;
  }
  createScUserTrip(
    trip_id: String,
    user_id: String,
    trip_type: String,
    drop_point: number,
    scheduled_date: String,
    start: any,
    end: any
  ): Promise<any> {
    let promise = new Promise((resolve, reject) => {
      var that = this;
      var myPromise = API.graphql(
        graphqlOperation(AppConstants.CreateScUserTrip, {
          trip_id: trip_id,
          user_id: user_id,
          trip_status: 0,
          trip_type: trip_type,
          otp: 123456,
          // otp: Math.floor(Math.random() * (+999999 - +100000)) + +100000,
          is_boarded: false,
          drop_point: drop_point,
          scheduled_date: scheduled_date,
          start_address: {
            lat: start.lat,
            long: start.long,
            address: start.address,
          },
          end_address: {
            lat: end.lat,
            long: end.long,
            address: end.address,
          },
        })
      ) as Promise<GraphQLResult>;
      myPromise
        .then((result) => {
          resolve(
            result.data[
            AppConstants.create + AppConstants.env + AppConstants.ScUserTrip
            ]
          );
        })
        .catch((error) => {
          reject(error);
        });
    });
    return promise;
  }

  createProdDaTrips(trips: any): Promise<any> {
    let promise = new Promise((resolve, reject) => {
      var that = this;
      var myPromise = API.graphql(
        graphqlOperation(AppConstants.CreateDaTrips, {
          created_at: trips.created_at,
          driver_id: trips.driver_id,
          trip_type: trips.trip_type,
          vehicle_no: trips.vehicle_no,
          trip_status: trips.trip_status,

          duty_start: {
            date_time: trips.duty_start_date,
            address: trips.duty_start_address,
          },
          duty_end: {
            date_time: trips.duty_end_date,
            address: trips.duty_end_address,
          },
        })
      ) as Promise<GraphQLResult>;
      myPromise
        .then((result) => {
          resolve(
            result.data[
            AppConstants.create + AppConstants.env + AppConstants.DaTrips
            ]
          );
        })
        .catch((error) => {
          reject(error);
        });
    });
    return promise;
  }

  createRnHrbotKeymapsSuggestions(
    context_key: any,
    context_query_val: any,
    context_suggestions: any,
    policy_names: any
  ): Promise<any> {
    let promise = new Promise((resolve, reject) => {
      var that = this;
      var myPromise = API.graphql(
        graphqlOperation(AppConstants.CreateRnHrbotKeymapsSuggestions, {
          context_key: context_key,
          context_query_val: context_query_val,
          context_suggestions: context_suggestions,
          policy_names: policy_names,
        })
      ) as Promise<GraphQLResult>;
      myPromise
        .then((result) => {
          resolve(
            result.data[
            AppConstants.create +
            AppConstants.env +
            AppConstants.RnHrbotKeymapsSuggestions
            ]
          );
        })
        .catch((error) => {
          reject(error);
        });
    });
    return promise;
  }

  //migration feedback
  createProdAppFitnessFeedback(feed: any): Promise<any> {
    let promise = new Promise((resolve, reject) => {
      var that = this;
      var myPromise = API.graphql(
        graphqlOperation(AppConstants.CreateAppFitnessFeedback, {
          rn_number: feed.rn_number,
          remarks: feed.remarks,
          timestamp: feed.timestamp,
          rating: feed.rating,
        })
      ) as Promise<GraphQLResult>;
      myPromise
        .then((result) => {
          resolve(
            result.data[
            AppConstants.create +
            AppConstants.env +
            AppConstants.CreateAppFitnessFeedback
            ]
          );
        })
        .catch((error) => {
          reject(error);
        });
    });
    return promise;
  }

  // create ScTripMaster ,
  createScTripMaster(
    driver_id: string,
    cab_id: string,
    trip_type: string,
    scheduled_date: string
  ): Promise<any> {
    let promise = new Promise((resolve, reject) => {
      var that = this;
      var myPromise = API.graphql(
        graphqlOperation(AppConstants.CreateScTripMaster, {
          driver_id: driver_id,
          cab_id: cab_id,
          scheduled_date: scheduled_date,
          trip_type: trip_type,
          status: 0,
          start_otp: Math.floor(Math.random() * (+999999 - +100000)) + +100000,
          end_otp: Math.floor(Math.random() * (+999999 - +100000)) + +100000,
        })
      ) as Promise<GraphQLResult>;
      console.log("createTripMaster executed");
      myPromise
        .then((result) => {
          resolve(
            result.data[
            AppConstants.create + AppConstants.env + AppConstants.ScTripMaster
            ]
          );
        })
        .catch((error) => {
          reject(error);
        });
    });
    return promise;
  }
  //cab master insert opertion

  //cab master insert opertion
  createScCabMaster(
    driver_id: String,
    driver_name: String,
    vehicle_no: String
  ): Promise<any> {
    let promise = new Promise((resolve, reject) => {
      var that = this;
      var myPromise = API.graphql(
        graphqlOperation(AppConstants.CreateScCabMaster, {
          driver_id: driver_id,
          driver_name: driver_name,
          vehicle_no: vehicle_no,
          no_seats: "5",
        })
      ) as Promise<GraphQLResult>;
      myPromise
        .then((result) => {
          resolve(
            result.data[
            AppConstants.create + AppConstants.env + AppConstants.ScCabMaster
            ]
          );
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
    return promise;
  }

  //

  // delete if exits id present in UserTrip Table
  deleteScUserTrip(id: String): Promise<any> {
    let promise = new Promise((resolve, reject) => {
      var myPromise = API.graphql(
        graphqlOperation(AppConstants.DeleteScUserTrip, { id: id })
      ) as Promise<GraphQLResult>;
      var that = this;
      myPromise
        .then((result) => {
          resolve(
            result.data[
            AppConstants.delete + AppConstants.env + AppConstants.ScUserTrip
            ]
          );
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
    return promise;
  }
  // deleteVehicleMaster(vehicle_no: String) : Promise<any> {
  //   let promise = new Promise((resolve, reject) => {
  //     var myPromise = API.graphql(graphqlOperation(AppConstants.DeleteVehicleMaster, { vehicle_no: vehicle_no })) as Promise<GraphQLResult>
  //     var that = this
  //     myPromise.then(result => {
  //       resolve(result.data["deleteVehicleMaster"]);
  //     }).catch(error => {
  //       console.log(error)
  //       reject(error)
  //     })
  //   });
  //   return promise;
  // }

  deleteDaVehicleMaster(id: String): Promise<any> {
    let promise = new Promise((resolve, reject) => {
      var myPromise = API.graphql(
        graphqlOperation(AppConstants.DeleteDaVehicleMaster, { id: id })
      ) as Promise<GraphQLResult>;
      var that = this;
      myPromise
        .then((result) => {
          resolve(
            result.data[
            AppConstants.delete +
            AppConstants.env +
            AppConstants.DaVehicleMaster
            ]
          );
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
    return promise;
  }

  deleteScTripMaster(id: String): Promise<any> {
    let promise = new Promise((resolve, reject) => {
      var myPromise = API.graphql(
        graphqlOperation(AppConstants.DeleteScTripMaster, { id: id })
      ) as Promise<GraphQLResult>;
      var that = this;
      myPromise
        .then((result) => {
          resolve(
            result.data[
            AppConstants.delete + AppConstants.env + AppConstants.ScTripMaster
            ]
          );
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
    return promise;
  }

  // // delete TripMaster Details
  // deleteTripMaster(id: String) : Promise<any> {
  //   let promise = new Promise((resolve, reject) => {
  //     var myPromise = API.graphql(graphqlOperation(AppConstants.DeleteTripMaster, { id: id })) as Promise<GraphQLResult>
  //     var that = this
  //     myPromise.then(result => {
  //       resolve(result.data["deleteTripMaster"]);
  //     }).catch(error => {
  //       console.log(error)
  //       reject(error)
  //     })
  //   });
  //   return promise;
  // }

  //create RNC users
  createRncUser(user: any): Promise<any> {
    let promise = new Promise((resolve, reject) => {
      var that = this;
      var myPromise = API.graphql(
        graphqlOperation(AppConstants.CreateRncUsers, {
          user_type: user.user_type,
          name: user.name,
          user_name: user.user_id,
          password: user.password,
          emergency_phone: user.emergency_phone,
          employee_phone: user.employee_phone,
          sos_enabled: 1,
          home_address: user.home_address,
        })
      ) as Promise<GraphQLResult>;
      // console.log("executed")
      myPromise
        .then((result) => {
          resolve(
            result.data[
            AppConstants.create + AppConstants.env + AppConstants.RncUsers
            ]
          );
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
    return promise;
  }
  //Update User Location
  updateRncUserLocation(id, lat, long, address): Promise<any> {
    let promise = new Promise((resolve, reject) => {
      var that = this;
      var myPromise = API.graphql(
        graphqlOperation(AppConstants.UpdateRncUsers, {
          id: id,
          home_address: {
            lat: lat,
            long: long,
            address: address,
          },
        })
      ) as Promise<GraphQLResult>;
      console.log("executed");
      myPromise
        .then((result) => {
          resolve(
            result.data[
            AppConstants.update + AppConstants.env + AppConstants.RncUsers
            ]
          );
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
    return promise;
  }

  //Update User Location
  updateRncUserType(id, userType): Promise<any> {
    let promise = new Promise((resolve, reject) => {
      var that = this;
      var myPromise = API.graphql(
        graphqlOperation(AppConstants.UpdateRncUsersType, {
          id: id,
          user_type: userType,
        })
      ) as Promise<GraphQLResult>;
      console.log("executed");
      myPromise
        .then((result) => {
          resolve(
            result.data[
            AppConstants.update + AppConstants.env + AppConstants.RncUsers
            ]
          );
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
    return promise;
  }

  /* 2019 rncuser */
  updateRncUserAssignType(id, userType): Promise<any> {
    let promise = new Promise((resolve, reject) => {
      var that = this;
      var myPromise = API.graphql(
        graphqlOperation(AppConstants.updateRncUserAssignType, {
          id: id,
          user_type: userType,
        })
      ) as Promise<GraphQLResult>;
      console.log("executed");
      myPromise
        .then((result) => {
          resolve(
            result.data[
            AppConstants.update + AppConstants.env + AppConstants.RncUsers
            ]
          );
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
    return promise;
  }

  //Update User Agency Type for Personal Users
  updatePersonalDriverAgency(id, agency_type): Promise<any> {
    let promise = new Promise((resolve, reject) => {
      var that = this;
      var myPromise = API.graphql(
        graphqlOperation(AppConstants.UpdateRncUsersAgency, {
          id: id,
          agency_type: agency_type,
        })
      ) as Promise<GraphQLResult>;
      console.log("executed");
      myPromise
        .then((result) => {
          resolve(
            result.data[
            AppConstants.update + AppConstants.env + AppConstants.RncUsers
            ]
          );
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
    return promise;
  }

  updateRncUsers(user, address): Promise<any> {
    let promise = new Promise((resolve, reject) => {
      var that = this;
      var myPromise = API.graphql(
        graphqlOperation(AppConstants.UpdateRncUsersData, {
          id: user.id,
          emergency_phone: "+91" + user.emergency_phone,
          employee_phone: "+91" + user.employee_phone,
          name: user.name,
          // password: userData.password,
          // profile_image: user.profile_image,
          user_name: user.user_name,
          user_type: user.user_type,
          sos_enabled: user.sos_enabled,
          home_address: {
            lat: address.lat,
            long: address.long,
            address: user.home_address,
          },
        })
      ) as Promise<GraphQLResult>;
      console.log("executed");
      myPromise
        .then((result) => {
          resolve(
            result.data[
            AppConstants.update + AppConstants.env + AppConstants.RncUsers
            ]
          );
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
    return promise;
  }

  updateRncUsersContact(user): Promise<any> {
    let promise = new Promise((resolve, reject) => {
      var that = this;
      var myPromise = API.graphql(
        graphqlOperation(AppConstants.UpdateRncUsersContact, {
          id: user.id,
          emergency_phone: user.emergency_phone,
          employee_phone: user.employee_phone,
        })
      ) as Promise<GraphQLResult>;
      console.log("executed");
      myPromise
        .then((result) => {
          resolve(
            result.data[
            AppConstants.update + AppConstants.env + AppConstants.RncUsers
            ]
          );
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
    return promise;
  }
  //get driver trip Details All
  getDriverAttendanceAll(created_at): Promise<any> {
    let promise = new Promise((resolve, reject) => {
      var myPromise = API.graphql(
        graphqlOperation(AppConstants.ListDaTrips, { created_at: created_at })
      ) as Promise<GraphQLResult>;
      var that = this;
      myPromise
        .then((result) => {
          that.userTrips =
            result.data[
              AppConstants.list + AppConstants.env + AppConstants.DaTrips
            ].items;
          resolve(that.userTrips);
        })
        .catch((error) => {
          reject(error);
        });
    });
    return promise;
  }

  getVehicleMaster(): Promise<any> {
    let promise = new Promise((resolve, reject) => {
      var that = this;
      var myPromise = API.graphql(
        graphqlOperation(AppConstants.ListDaVehicleMasters)
      ) as Promise<GraphQLResult>;
      myPromise
        .then((result) => {
          console.log("RSULT", result);
          resolve(
            result.data[
              AppConstants.list +
              AppConstants.env +
              AppConstants.listDaVehicleMasters
            ].items
          );
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
    return promise;
  }

  getVehicleMasterByUser(user_id): Promise<any> {
    let promise = new Promise((resolve, reject) => {
      var that = this;
      var myPromise = API.graphql(
        graphqlOperation(AppConstants.ListDaVehicleMastersByUser, {
          user_id: user_id,
        })
      ) as Promise<GraphQLResult>;
      myPromise
        .then((result) => {
          console.log("RSULT", result);
          resolve(
            result.data[
              AppConstants.list +
              AppConstants.env +
              AppConstants.listDaVehicleMasters
            ].items
          );
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
    return promise;
  }

  getVehicleMasterByDriver(driver_id): Promise<any> {
    let promise = new Promise((resolve, reject) => {
      var that = this;
      var myPromise = API.graphql(
        graphqlOperation(AppConstants.ListDaVehicleMastersByDriver, {
          driver_id: driver_id,
        })
      ) as Promise<GraphQLResult>;
      myPromise
        .then((result) => {
          console.log("RSULT", result);
          resolve(
            result.data[
              AppConstants.list +
              AppConstants.env +
              AppConstants.listDaVehicleMasters
            ].items
          );
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
    return promise;
  }

  //get vehicle Master
  // getVehicleMasterAll(searchData): Promise<any> {
  //   let promise = new Promise((resolve, reject) => {
  //     var that = this;
  //     var myPromise = API.graphql(
  //       graphqlOperation(this.getVehicleMstQueryFormation(searchData))
  //     ) as Promise<GraphQLResult>;
  //     myPromise
  //       .then((result) => {
  //         resolve(
  //           result.data[
  //             AppConstants.list +
  //               AppConstants.env +
  //               AppConstants.listDaVehicleMasters
  //           ].items
  //         );
  //       })
  //       .catch((error) => {
  //         console.log(error);
  //         reject(error);
  //       });
  //   });
  //   return promise;
  // }

  // getVehicleMstQueryFormation(searchFilter) {
  //   let filterstr = "";
  //   //console.log(searchFilter)
  //   if (searchFilter.driver_id != "") {
  //     filterstr = filterstr.concat(
  //       filterstr,
  //       AppConstants.driverIDFilterCons +
  //         searchFilter.driver_id +
  //         AppConstants.filterend
  //     );
  //   }
  //   if (searchFilter.vehicle_no != "") {
  //     filterstr = filterstr.concat(
  //       filterstr,
  //       AppConstants.vehicleNoFilterCons +
  //         searchFilter.vehicle_no +
  //         AppConstants.filterend
  //     );
  //   }
  //   if (searchFilter.user_name != "") {
  //     filterstr = filterstr.concat(
  //       filterstr,
  //       AppConstants.userNameFilterCons +
  //         searchFilter.user_name +
  //         AppConstants.filterend
  //     );
  //   }
  //   if (searchFilter.agency_type != "") {
  //     filterstr = filterstr.concat(
  //       filterstr,
  //       AppConstants.agencyTypeFilterCons +
  //         searchFilter.agency_type +
  //         AppConstants.filterend
  //     );
  //   }
  //   let query = "";
  //   if (filterstr == "") {
  //     query = AppConstants.ListDaVehicleMasters;
  //   } else {
  //     query =
  //       `query ` +
  //       AppConstants.list +
  //       AppConstants.env +
  //       AppConstants.listDaVehicleMasters +
  //       `
  //     {
  //       ` +
  //       AppConstants.list +
  //       AppConstants.env +
  //       AppConstants.listDaVehicleMasters +
  //       ` (filter: {` +
  //       filterstr +
  //       `})` +
  //       AppConstants.listDaVehicleMastersItems +
  //       `}`;
  //   }

  //   console.log("11111111", query);
  //   return query;
  // }

  getVehicleMasterAll(searchData): Promise<any> {
    let promise = new Promise((resolve, reject) => {
      var that = this;
      var myPromise = API.graphql(
        graphqlOperation(this.getVehicleMstQueryFormation(searchData))
      ) as Promise<GraphQLResult>;
      myPromise
        .then((result) => {
          resolve(
            result.data[
              AppConstants.list +
              AppConstants.env +
              AppConstants.listDaVehicleMasters
            ].items
          );
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
    return promise;
  }

  getVehicleMstQueryFormation(searchFilter) {
    let filterstr = "";
    //console.log(searchFilter)
    if (searchFilter.driver_id != "") {
      filterstr = "driver_id : { in: " +
        JSON.stringify(searchFilter.driver_id) + "}";
      // searchFilter.driver_id = searchFilter.driver_id.map((id) => {
      //   let idstr = '';
      //   idstr = idstr.concat(filterstr,"{"+
      //    AppConstants.driverIDFilterCons +
      //     id +
      //     AppConstants.filterend)+"}";
      //   return idstr;
      // });

      // filterstr = filterstr.concat(
      //   filterstr,
      //   AppConstants.orFilterCons +
      //     JSON.stringify(searchFilter.driver_id) +
      //     AppConstants.orFilterConsEnd
      // );
      console.log(JSON.parse(JSON.stringify(filterstr)), "filterstr::::::::::::::::");

    }
    if (searchFilter.vehicle_no != "") {
      const vehicle_no = AppConstants.vehicleNoFilterCons +
        searchFilter.vehicle_no +
        AppConstants.filterend;
      filterstr = filterstr + vehicle_no;
    }
    if (searchFilter.user_name != "") {
      const user_name = AppConstants.userNameFilterCons +
        searchFilter.user_name + AppConstants.filterend;
      filterstr = filterstr + user_name;
    }
    if (searchFilter.agency_type != "") {
      const agency_type = AppConstants.agencyTypeFilterCons +
        searchFilter.agency_type +
        AppConstants.filterend;
      filterstr = filterstr + agency_type;
    }
    let query = "";
    if (filterstr == "") {
      query = AppConstants.ListDaVehicleMasters;
    } else {
      query =
        `query ` +
        AppConstants.list +
        AppConstants.env +
        AppConstants.listDaVehicleMasters +
        `
      {
        ` +
        AppConstants.list +
        AppConstants.env +
        AppConstants.listDaVehicleMasters +
        ` (filter: {` +
        filterstr +
        `})` +
        AppConstants.listDaVehicleMastersItems +
        `}`;
    }

    console.log("11111111", query);
    return query;
  }






  ScUserTripFilter(searchFilter: any, nextToken) {
    console.log("searchFilter", searchFilter);

    let filterstr = "";

    if (searchFilter.scheduled_date != "") {
      filterstr = filterstr.concat(
        filterstr,
        AppConstants.schduledDateFilterCons +
        searchFilter.scheduled_date +
        AppConstants.filterend
      );
    }
    if (searchFilter.user_id != "") {
      filterstr = filterstr.concat(
        filterstr,
        AppConstants.userIdFilterCons +
        searchFilter.user_id +
        AppConstants.filterend
      );
    }

    if (searchFilter.trip_type != "") {
      filterstr = filterstr.concat(
        filterstr,
        AppConstants.tripTypeFilterCons +
        searchFilter.trip_type +
        AppConstants.filterIntend
      );
    }
    if (searchFilter.trip_status != "") {
      filterstr = filterstr.concat(
        filterstr,
        AppConstants.tripStatusFilterCons +
        searchFilter.trip_status +
        AppConstants.filterIntend
      );
    }

    let nextTokenIn = "";
    if (nextToken != null || nextToken != "") {
      nextTokenIn = `nextToken : "` + nextToken + `"`;
    }

    let query = "";
    if (filterstr == "") {
      query = AppConstants.getScUserTripByDriverAll;
    } else {
      query =
        `query ` +
        AppConstants.list +
        AppConstants.env +
        AppConstants.listScUserTrips +
        `
      {
        ` +
        AppConstants.list +
        AppConstants.env +
        AppConstants.listScUserTrips +
        ` (filter: {` +
        filterstr +
        `}
      ` +
        nextTokenIn +
        `)` +
        AppConstants.ScUserTripItmes +
        `}`;
    }

    console.log("query", query);
    let promise = new Promise((resolve, reject) => {
      var that = this;
      var myPromise = API.graphql(
        graphqlOperation(query)
      ) as Promise<GraphQLResult>;
      myPromise
        .then((result) => {
          let data = { items: {}, nextToken: String };
          data.items =
            result.data[
              AppConstants.list +
              AppConstants.env +
              AppConstants.listScUserTrips
            ].items;
          data.nextToken =
            result.data[
              AppConstants.list +
              AppConstants.env +
              AppConstants.listScUserTrips
            ].nextToken;

          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
    return promise;
  }

  driverAttendanceFilter(searchFilter: any, nextToken) {
    let intimeStr = "";
    let outtimeStr = "";
    let outStationStr = "";
    let nextTokenIn = "";
    if (nextToken != null && nextToken != "") {
      nextTokenIn = `nextToken : "` + nextToken + `"`;
    }

    let filterstr = "";
    if (searchFilter.drivers.length > 0) {
      filterstr = filterstr.concat(
        filterstr,
        AppConstants.driverIDFilterCons +
        searchFilter.drivers[0].id +
        AppConstants.filterend
      );
    }

    if (searchFilter.vehicles.length > 0) {
      filterstr = filterstr.concat(
        filterstr,
        AppConstants.vehicleNoFilterCons +
        searchFilter.vehicles[0] +
        AppConstants.filterend
      );
    }

    if (searchFilter.dutyStart != "" && searchFilter.dutyEnd != "") {
      intimeStr =
        ` created_at : { ge :"` +
        searchFilter.dutyStart +
        `"
                               le :"` +
        searchFilter.dutyEnd +
        `"}`;
      filterstr = filterstr.concat(filterstr, intimeStr);
    }
    if (searchFilter.dutyStart != "" && searchFilter.dutyEnd == "") {
      intimeStr = ` created_at : { ge :"` + searchFilter.dutyStart + `" }`;
      filterstr = filterstr.concat(filterstr, intimeStr);
    }
    if (searchFilter.dutyStart == "" && searchFilter.dutyEnd != "") {
      outtimeStr = ` created_at : { le :"` + searchFilter.dutyEnd + `" }`;
      filterstr = filterstr.concat(filterstr, outtimeStr);
    }
    if (searchFilter.outStation != "") {
      outStationStr = ` trip_type : { eq :"` + searchFilter.outStation + `" }`;
      filterstr = filterstr.concat(filterstr, outStationStr);
    }

    let query = "";
    if (filterstr == "") {
      query = AppConstants.ListDaTrips;
    } else {
      query =
        `query ` +
        AppConstants.list +
        AppConstants.env +
        AppConstants.DaTrips +
        `
      {
        ` +
        AppConstants.list +
        AppConstants.env +
        AppConstants.DaTrips +
        ` (filter: {` +
        filterstr +
        `}   ` +
        nextTokenIn +
        `) {` +
        `nextToken` +
        AppConstants.DaTripsItmes +
        `} }`;
    }

    console.log("QUERY");
    console.log(query);
    let promise = new Promise((resolve, reject) => {
      var that = this;
      var myPromise = API.graphql(
        graphqlOperation(query)
      ) as Promise<GraphQLResult>;
      myPromise
        .then((result) => {
          let data = { items: {}, nextToken: String };
          data.items =
            result.data[
              AppConstants.list + AppConstants.env + AppConstants.DaTrips
            ].items;
          data.nextToken =
            result.data[
              AppConstants.list + AppConstants.env + AppConstants.DaTrips
            ].nextToken;
          console.log("data", data);
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
    return promise;
  }
  // private handleError(error: any) {
  //   let errMsg = (error.message) ? error.message : error.status ? `${error.status} - ${error.statusText}` : 'Server error';
  //   return Observable.throw(error);
  // }
  handleError(error: any) {
    let errormsg = error.errors;
    errormsg.forEach((element) => {
      return Observable.throw(element.message);
    });
  }
  // trip position
  getScTripPosition(trip_id): Promise<any> {
    let promise = new Promise((resolve, reject) => {
      var that = this;
      var myPromise = API.graphql(
        graphqlOperation(AppConstants.GetScTripPosition, { trip_id: trip_id })
      ) as Promise<GraphQLResult>;
      myPromise
        .then((result) => {
          resolve(
            result.data[
            AppConstants.getq + AppConstants.env + AppConstants.ScTripPosition
            ]
          );
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
    return promise;
  }
  //Finished Trip Screen services------------------------------------------------------------------------------
  getTripsByStatus(status, lecondition, gecondition) {
    console.log("lecondition", lecondition);
    console.log("gecondition", gecondition);
    let promise = new Promise((resolve, reject) => {
      var that = this;
      var Query =
        status == 2
          ? AppConstants.getCompletedTrip
          : AppConstants.getRemainingTrip;
      var myPromise = API.graphql(
        graphqlOperation(Query, {
          status: status,
          lecondition: lecondition,
          gecondition: gecondition,
        })
      ) as Promise<GraphQLResult>;
      myPromise
        .then((result) => {
          console.log("result", result);
          resolve(
            result.data[
              AppConstants.list +
              AppConstants.env +
              AppConstants.listScTripMasters
            ].items
          );
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
    return promise;
  }

  getTripsByStatusNextToken(status, lecondition, gecondition, nexttoken) {
    console.log("lecondition", lecondition);
    console.log("gecondition", gecondition);
    let promise = new Promise((resolve, reject) => {
      var that = this;
      var Query =
        status == 2
          ? AppConstants.getCompletedTripNextToken
          : AppConstants.getRemainingTripNextToken;
      console.log("Query", Query);
      var myPromise = API.graphql(
        graphqlOperation(Query, {
          status: status,
          lecondition: lecondition,
          gecondition: gecondition,
          nextToken: nexttoken,
        })
      ) as Promise<GraphQLResult>;
      myPromise
        .then((result) => {
          console.log("result", result);

          let data = { items: {}, nextToken: String };
          data.items =
            result.data[
              AppConstants.list +
              AppConstants.env +
              AppConstants.listScTripMasters
            ].items;
          data.nextToken =
            result.data[
              AppConstants.list +
              AppConstants.env +
              AppConstants.listScTripMasters
            ].nextToken;
          resolve(data);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
    return promise;
  }

  //
  getTripsByStatusCnt(status, scheduled_date) {
    let promise = new Promise((resolve, reject) => {
      var that = this;
      var Query =
        status == 2
          ? AppConstants.getCompletedTripCnt
          : AppConstants.getRemainingTripCnt;
      console.log("Query", Query);
      var myPromise = API.graphql(
        graphqlOperation(Query, {
          status: status,
          scheduled_date: scheduled_date,
        })
      ) as Promise<GraphQLResult>;
      myPromise
        .then((result) => {
          console.log("result", result);
          resolve(
            result.data[
              AppConstants.list +
              AppConstants.env +
              AppConstants.listScTripMasters
            ].items
          );
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
    return promise;
  }
  getCurrentDayTrip(today) {
    let promise = new Promise((resolve, reject) => {
      var that = this;
      var myPromise = API.graphql(
        graphqlOperation(AppConstants.GetCurrentDayTrip, { today: today })
      ) as Promise<GraphQLResult>;
      myPromise
        .then((result) => {
          resolve(
            result.data[
              AppConstants.list +
              AppConstants.env +
              AppConstants.listScTripMasters
            ].items
          );
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
    return promise;
  }

  getCurrentDayTripNextToken(today, nexttoken) {
    let promise = new Promise((resolve, reject) => {
      var that = this;
      var myPromise = API.graphql(
        graphqlOperation(AppConstants.GetCurrentDayTripNextToken, {
          today: today,
          nextToken: nexttoken,
        })
      ) as Promise<GraphQLResult>;
      myPromise
        .then((result) => {
          let data = { items: {}, nextToken: String };
          data.items =
            result.data[
              AppConstants.list +
              AppConstants.env +
              AppConstants.listScTripMasters
            ].items;
          data.nextToken =
            result.data[
              AppConstants.list +
              AppConstants.env +
              AppConstants.listScTripMasters
            ].nextToken;

          resolve(data);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
    return promise;
  }
  getCurrentDayRunningTrip(tomorrow, today) {
    let promise = new Promise((resolve, reject) => {
      var that = this;
      var myPromise = API.graphql(
        graphqlOperation(AppConstants.GetCurrentDayTrip, {
          tomorrow: tomorrow,
          today: today,
        })
      ) as Promise<GraphQLResult>;
      myPromise
        .then((result) => {
          resolve(
            result.data[
              AppConstants.list +
              AppConstants.env +
              AppConstants.listScTripMasters
            ].items
          );
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
    return promise;
  }
  getScUserTripByDriverAll(scheduled_date) {
    let promise = new Promise((resolve, reject) => {
      var that = this;
      var myPromise = API.graphql(
        graphqlOperation(AppConstants.getScUserTripByDriverAll, {
          scheduled_date: scheduled_date,
        })
      ) as Promise<GraphQLResult>;
      myPromise
        .then((result) => {
          resolve(
            result.data[
              AppConstants.list +
              AppConstants.env +
              AppConstants.listScUserTrips
            ].items
          );
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
    return promise;
  }
  getUserTripByDriverId(trip_id, driver_id) {
    let promise = new Promise((resolve, reject) => {
      var that = this;
      var myPromise = API.graphql(
        graphqlOperation(AppConstants.getScUserTripByDriver, {
          trip_id: trip_id,
          user_id: driver_id,
        })
      ) as Promise<GraphQLResult>;
      myPromise
        .then((result) => {
          resolve(
            result.data[
              AppConstants.list +
              AppConstants.env +
              AppConstants.listScUserTrips
            ].items
          );
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
    return promise;
  }
  getScUserTripUser(trip_id) {
    let promise = new Promise((resolve, reject) => {
      var that = this;
      var myPromise = API.graphql(
        graphqlOperation(AppConstants.GetScUserTripUser, { trip_id: trip_id })
      ) as Promise<GraphQLResult>;
      myPromise
        .then((result) => {
          resolve(
            result.data[
              AppConstants.list +
              AppConstants.env +
              AppConstants.listScUserTrips
            ].items
          );
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
    return promise;
  }

  getScUserTripUserId(trip_id, user_id, scheduled_date) {
    let promise = new Promise((resolve, reject) => {
      var that = this;
      var myPromise = API.graphql(
        graphqlOperation(AppConstants.GetScUserTripUserId, {
          trip_id: trip_id,
          user_id: user_id,
          scheduled_date: scheduled_date,
        })
      ) as Promise<GraphQLResult>;
      myPromise
        .then((result) => {
          resolve(
            result.data[
              AppConstants.list +
              AppConstants.env +
              AppConstants.listScUserTrips
            ].items
          );
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
    return promise;
  }
  getScUserTipByTripId(trip_id) {
    let promise = new Promise((resolve, reject) => {
      var that = this;
      var myPromise = API.graphql(
        graphqlOperation(AppConstants.GetScUserTripTripId, { trip_id: trip_id })
      ) as Promise<GraphQLResult>;
      myPromise
        .then((result) => {
          resolve(
            result.data[
              AppConstants.list +
              AppConstants.env +
              AppConstants.listScUserTrips
            ].items
          );
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
    return promise;
  }

  getScUserTipByTripIdAllFields(trip_id) {
    let promise = new Promise((resolve, reject) => {
      var that = this;
      var myPromise = API.graphql(
        graphqlOperation(AppConstants.getScUserTripByTripIdAllFields, {
          trip_id: trip_id,
        })
      ) as Promise<GraphQLResult>;
      myPromise
        .then((result) => {
          resolve(
            result.data[
              AppConstants.list +
              AppConstants.env +
              AppConstants.listScUserTrips
            ].items
          );
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
    return promise;
  }

  getScUserTripId(trip_id) {
    let promise = new Promise((resolve, reject) => {
      var that = this;
      var myPromise = API.graphql(
        graphqlOperation(AppConstants.GetScUserTripId, { trip_id: trip_id })
      ) as Promise<GraphQLResult>;
      myPromise
        .then((result) => {
          resolve(
            result.data[
              AppConstants.list +
              AppConstants.env +
              AppConstants.listScUserTrips
            ].items
          );
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
    return promise;
  }

  getScUserTripByTripId(trip_id) {
    let promise = new Promise((resolve, reject) => {
      var that = this;
      var myPromise = API.graphql(
        graphqlOperation(AppConstants.GetScUserTripByTripId, {
          trip_id: trip_id,
        })
      ) as Promise<GraphQLResult>;
      myPromise
        .then((result) => {
          resolve(
            result.data[
              AppConstants.list +
              AppConstants.env +
              AppConstants.listScUserTrips
            ].items
          );
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
    return promise;
  }

  getRncUsers(id) {
    let promise = new Promise((resolve, reject) => {
      var that = this;
      var myPromise = API.graphql(
        graphqlOperation(AppConstants.GetRncUsers, { id: id })
      ) as Promise<GraphQLResult>;
      myPromise
        .then((result) => {
          resolve(
            result.data[
            AppConstants.getq + AppConstants.env + AppConstants.RncUsers
            ]
          );
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
    return promise;
  }

  SearchRncUsers(searchFilter: any, nextToken: String) {
    let filterstr = "";
    if (searchFilter.user_name != "") {
      filterstr = filterstr.concat(
        filterstr,
        AppConstants.userNameFilterCons +
        searchFilter.user_name +
        AppConstants.filterend
      );
    }
    // if (searchFilter.user_type != "") {
    //   filterstr = filterstr.concat(filterstr, AppConstants.userTypeFilterCons + searchFilter.user_type + AppConstants.filterIntend)
    // }
    let nextTokenIn = "";
    if (nextToken != null || nextToken != "") {
      nextTokenIn = `,nextToken : "` + nextToken + `"`;
    }

    let query = "";
    if (filterstr == "" && nextTokenIn == "") {
      query = AppConstants.ListRncUsers;
    } else if (filterstr == "" && nextTokenIn != "") {
      query =
        `query ` +
        AppConstants.list +
        AppConstants.env +
        AppConstants.RncUsers +
        `
      {
        ` +
        AppConstants.list +
        AppConstants.env +
        AppConstants.RncUsers +
        ` (
        nextToken : "` +
        nextToken +
        `"` +
        ` )` +
        AppConstants.RncUserItem +
        `}`;
    } else {
      query =
        `query ` +
        AppConstants.list +
        AppConstants.env +
        AppConstants.RncUsers +
        `
      {
        ` +
        AppConstants.list +
        AppConstants.env +
        AppConstants.RncUsers +
        ` (filter: {` +
        filterstr +
        `}
        ` +
        nextTokenIn +
        ` )` +
        AppConstants.RncUserItem +
        `}`;
    }

    console.log("query", AppConstants.RncUserItem);
    console.log("query", query);

    let promise = new Promise((resolve, reject) => {
      var that = this;
      var myPromise = API.graphql(
        graphqlOperation(query, {})
      ) as Promise<GraphQLResult>;
      myPromise
        .then((result) => {
          console.log("RNC", result);
          resolve(
            result.data[
            AppConstants.list + AppConstants.env + AppConstants.RncUsers
            ]
          );
        })
        .catch((error) => {
          reject(error);
        });
    });
    return promise;
  }
  /* ############### DRIVER MODULE ################### */
  getDriverList(): Promise<any> {
    let promise = new Promise((resolve, reject) => {
      var that = this;
      //getDriverList
      var myPromise = API.graphql(
        graphqlOperation(AppConstants.getDriverList)
      ) as Promise<GraphQLResult>;
      myPromise
        .then((result) => {
          resolve(
            result.data[
              AppConstants.list +
              AppConstants.env +
              AppConstants.listCpDriverMaster
            ].items
          );
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
    return promise;
  }

  getDriverListbyPid(pid: string): Promise<any> {
    let promise = new Promise((resolve, reject) => {
      var that = this;
      //getDriverList
      var myPromise = API.graphql(
        graphqlOperation(AppConstants.getDriverListByPid, { user_pid: pid })
      ) as Promise<GraphQLResult>;
      myPromise
        .then((result) => {
          resolve(
            result.data[
              AppConstants.list +
              AppConstants.env +
              AppConstants.listCpDriverMaster
            ].items
          );
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
    return promise;
  }
  CreateDriverData(driverData): Promise<any> {
    console.log("-------------------", driverData);
    let promise = new Promise((resolve, reject) => {
      var myPromise = API.graphql(
        graphqlOperation(AppConstants.CreateDriverData, {
          user_pid: driverData.user_pid,
          driver_name: driverData.driver_name,
          date_of_birth: driverData.date_of_birth,
          driving_license_no: driverData.driving_license_no,
          license_exp_date: driverData.license_exp_date,
          vendor_name: driverData.vendor_name,
          is_active: driverData.is_active,
          is_assigned: driverData.is_assigned,
          ex_data: driverData.ex_data,
          created_date: driverData.created_date,
          updated_date: driverData.updated_date,
        })
      ) as Promise<GraphQLResult>;
      myPromise
        .then((result) => {
          console.log("result", result);
          resolve(
            result.data[
            AppConstants.create +
            AppConstants.env +
            AppConstants.updateCpDriverMaster
            ]
          );
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
    return promise;
  }

  UpdateDriverData(driverData): Promise<any> {
    console.log("-------------------", driverData);
    let promise = new Promise((resolve, reject) => {
      var myPromise = API.graphql(
        graphqlOperation(AppConstants.UpdateDriverData, {
          id: driverData.id,
          user_pid: driverData.user_pid,
          driver_name: driverData.driver_name,
          date_of_birth: driverData.date_of_birth,
          driving_license_no: driverData.driving_license_no,
          license_exp_date: driverData.license_exp_date,
          vendor_name: driverData.vendor_name,
          is_active: driverData.is_active,
          is_assigned: driverData.is_assigned,
          ex_data: driverData.ex_data,
          created_date: driverData.created_date,
          updated_date: driverData.updated_date,
        })
      ) as Promise<GraphQLResult>;
      myPromise
        .then((result) => {
          console.log("result", result);
          resolve(
            result.data[
            AppConstants.update +
            AppConstants.env +
            AppConstants.updateCpDriverMaster
            ]
          );
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
    return promise;
  }

  deleteDriverData(id: String): Promise<any> {
    let promise = new Promise((resolve, reject) => {
      var myPromise = API.graphql(
        graphqlOperation(AppConstants.deleteDriverData, { id: id })
      ) as Promise<GraphQLResult>;
      var that = this;
      myPromise
        .then((result) => {
          resolve(
            result.data[
            AppConstants.delete +
            AppConstants.env +
            AppConstants.updateCpDriverMaster
            ]
          );
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
    return promise;
  }

  getDriverFeedbackList(): Promise<any> {
    let promise = new Promise((resolve, reject) => {
      var that = this;
      //getDriverList
      var myPromise = API.graphql(
        graphqlOperation(AppConstants.getDriverFeedbackList)
      ) as Promise<GraphQLResult>;
      myPromise
        .then((result) => {
          resolve(
            result.data[
              AppConstants.list +
              AppConstants.env +
              AppConstants.listCpDriverFeedback
            ].items
          );
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
    return promise;
  }

  updateDriverFeedbackStat(id: String, status: string): Promise<any> {
    let promise = new Promise((resolve, reject) => {
      var dt = new Date();
      var myPromise = API.graphql(
        graphqlOperation(AppConstants.UpdateDriverFeedbackData, {
          id: id,
          ex_data: status,
          updated_date: dt.toISOString(),
        })
      ) as Promise<GraphQLResult>;
      var that = this;
      myPromise
        .then((result) => {
          resolve(
            result.data[
            AppConstants.update +
            AppConstants.env +
            AppConstants.updateCpDriverFeedback
            ]
          );
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
    return promise;
  }

  getDriverConcernList(): Promise<any> {
    let promise = new Promise((resolve, reject) => {
      var that = this;
      //getDriverList
      var myPromise = API.graphql(
        graphqlOperation(AppConstants.getDriverConcernList)
      ) as Promise<GraphQLResult>;
      myPromise
        .then((result) => {
          resolve(
            result.data[
              AppConstants.list +
              AppConstants.env +
              AppConstants.listCpDriverConcern
            ].items
          );
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
    return promise;
  }

  updateDriverConcernStat(DriverConcernStat): Promise<any> {
    let promise = new Promise((resolve, reject) => {
      var dt = new Date();
      var myPromise = API.graphql(
        graphqlOperation(
          AppConstants.UpdateDriverConcernData,
          DriverConcernStat
        )
      ) as Promise<GraphQLResult>;
      var that = this;
      myPromise
        .then((result) => {
          resolve(
            result.data[
            AppConstants.update +
            AppConstants.env +
            AppConstants.updateCpDriverConcern
            ]
          );
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
    return promise;
  }

  getAssignedDriverList(): Promise<any> {
    let promise = new Promise((resolve, reject) => {
      var that = this;
      //getDriverList
      var myPromise = API.graphql(
        graphqlOperation(AppConstants.getAssignedDriver)
      ) as Promise<GraphQLResult>;
      myPromise
        .then((result) => {
          resolve(
            result.data[
              AppConstants.list +
              AppConstants.env +
              AppConstants.listCpAssignedDriver
            ].items
          );
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
    return promise;
  }
  CreateDriverAssignData(driverAssignData): Promise<any> {
    console.log("-------------------", driverAssignData);
    let promise = new Promise((resolve, reject) => {
      var myPromise = API.graphql(
        graphqlOperation(AppConstants.CreateDriverAssignData, {
          assigned_date: driverAssignData.assigned_date,
          end_date: driverAssignData.end_date,
          driver_id: driverAssignData.driver_id,
          username: driverAssignData.username,
          user_pid: driverAssignData.user_pid,
          status: driverAssignData.status,
          ex_data: driverAssignData.ex_data,
          created_date: driverAssignData.created_date,
          updated_date: driverAssignData.updated_date,
        })
      ) as Promise<GraphQLResult>;
      myPromise
        .then((result) => {
          console.log("result", result);
          resolve(
            result.data[
            AppConstants.create +
            AppConstants.env +
            AppConstants.updateCpAssignedDriver
            ]
          );
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
    return promise;
  }
  UpdateDriverAssignData(driverAssignData): Promise<any> {
    console.log("-------------------", driverAssignData);
    let promise = new Promise((resolve, reject) => {
      var myPromise = API.graphql(
        graphqlOperation(AppConstants.UpdateDriverAssignData, {
          id: driverAssignData.id,
          assigned_date: driverAssignData.assigned_date,
          end_date: driverAssignData.end_date,
          driver_id: driverAssignData.driver_id,
          username: driverAssignData.username,
          user_pid: driverAssignData.user_pid,
          status: driverAssignData.status,
          ex_data: driverAssignData.ex_data,
          created_date: driverAssignData.created_date,
          updated_date: driverAssignData.updated_date,
        })
      ) as Promise<GraphQLResult>;
      myPromise
        .then((result) => {
          console.log("result", result);
          resolve(
            result.data[
            AppConstants.update +
            AppConstants.env +
            AppConstants.updateCpAssignedDriver
            ]
          );
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
    return promise;
  }

  rnUserFilterById(userid: String): Promise<any> {
    let promise = new Promise((resolve, reject) => {
      var that = this;
      console.log("rnUserFilterById", AppConstants.rnUserFilterbyId);
      var myPromise = API.graphql(
        graphqlOperation(AppConstants.rnUserFilterbyId, { id: userid })
      ) as Promise<GraphQLResult>;
      myPromise
        .then((result) => {
          //  console.log(AppConstants.list + AppConstants.env + AppConstants.RncUsers)
          resolve(
            result.data[
            AppConstants.getq + AppConstants.env + AppConstants.RncUsers
            ]
          );
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
    return promise;
  }

  /* ############### DRIVER MODULE ################### */

  getMiscData(data_key: string): Promise<any> {
    let promise = new Promise((resolve, reject) => {
      var myPromise = API.graphql(
        graphqlOperation(AppConstants.getMiscData, { data_key: data_key })
      ) as Promise<GraphQLResult>;
      myPromise
        .then((result) => {
          console.log("getMiscData", result);
          resolve(
            result.data[
              AppConstants.list + AppConstants.env + AppConstants.listMiscData
            ].items
          );
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
    return promise;
  }

  updateMiscData(
    id: string,
    data_key: string,
    data_value: string
  ): Promise<any> {
    let promise = new Promise((resolve, reject) => {
      var myPromise = API.graphql(
        graphqlOperation(AppConstants.updateMiscDataByKey, {
          id: id,
          data_key: data_key,
          data_value: data_value,
        })
      ) as Promise<GraphQLResult>;
      myPromise
        .then((result) => {
          console.log("updateMiscDataByKey", result);
          resolve(
            result.data[
              AppConstants.update +
              AppConstants.env +
              AppConstants.updateMiscData
            ].items
          );
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
    return promise;
  }

  private TAG = 'AwsLoginCredentialsProvider';
  private QUERY_KEY = {
    UPDATE_USERS: AppConstants.update + environment.dbPrefix + 'RncUsers',
  };
  private UpdateIsTempPassword =
    `mutation ` +
    this.QUERY_KEY.UPDATE_USERS +
    `($id: ID!, $password: String, $is_temporary_password: String) {
` +
    this.QUERY_KEY.UPDATE_USERS +
    `(input:{id: $id, password: $password, is_temporary_password: $is_temporary_password }) {
  id
  password
  is_temporary_password
}
}`;
  updateIsTempPassword(
    id: String,
    password: String,
    is_temporary_password: String
  ): Promise<any> {
    let promise = new Promise((resolve, reject) => {
      let myPromise = API.graphql(
        graphqlOperation(this.UpdateIsTempPassword, {
          id: id,
          password: password,
          is_temporary_password: is_temporary_password,
        })
      ) as Promise<GraphQLResult>;
      myPromise
        .then((result) => {
          console.log(
            '[INFO] ' + this.TAG + ' - isTempPassword : onSuccess : ',
            result.data
          );
          resolve(result.data);
        })
        .catch((error) => {
          console.log(
            '[Error] ' + this.TAG + ' - isTempPassword : onError : ',
            error
          );
          reject(error);
        });
    });
    return promise;
  }
}
